
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("j3Lmi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7b4ac42d40f409f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $fWqHN = parcelRequire("fWqHN");

var $5qVrc = parcelRequire("5qVrc");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");

var $hQFKP = parcelRequire("hQFKP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b4ac42d40f409f5$export$2e2bcd8739ae039 = ({ queries: queries, extraProps: { isAdminProjectDirectoryRoute: isAdminProjectDirectoryRoute } })=>{
    const metricsConfig = (0, $5uXOq.useMemo)(()=>isAdminProjectDirectoryRoute ? (0, $hQFKP.METRICS_CONFIG).admin : (0, $hQFKP.METRICS_CONFIG).default, [
        isAdminProjectDirectoryRoute
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: metricsConfig.sourceName,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experience: metricsConfig.experienceKey,
        analyticsSource: metricsConfig.experienceSource
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qVrc.default), {
        id: metricsConfig.errorBoundary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "projects-directory-v3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWqHN.default), {
        isAdminSettingsContext: isAdminProjectDirectoryRoute,
        queries: queries
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fWqHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2a7ebf5ca2a77a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $fZneA = parcelRequire("fZneA");

var $lfTZh = parcelRequire("lfTZh");

var $gkT9B = parcelRequire("gkT9B");

var $ao2h1 = parcelRequire("ao2h1");

var $hW253 = parcelRequire("hW253");

var $dpo6O = parcelRequire("dpo6O");
const $2e2a7ebf5ca2a77a$var$ProjectsDirectoryContainer = ({ isAdminSettingsContext: isAdminSettingsContext, queries: queries })=>{
    const queryReference = queries?.projectsDirectoryPage ? queries.projectsDirectoryPage : (0, $ao2h1.useRelayResource)((0, $hW253.projectsDirectoryPageResource), {
        suspendWhenLoading: false
    }).queryReference;
    const experienceKey = isAdminSettingsContext ? (0, $gkT9B.MANAGE_PROJECTS_DIRECTORY_EXPERIENCE) : (0, $gkT9B.PROJECTS_DIRECTORY_EXPERIENCE);
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experienceKey
    });
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experienceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "app-container",
        packageName: "jiraProjectsDirectoryV3",
        onError: (...args)=>{
            const [, error] = args;
            (0, $fZneA.isHttpClientErrorResponse)(error) ? onSuccess({
                view: 'fallback-error-page'
            }) : onFail(...args);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-directory-layout",
        fallback: null
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpo6O.ProjectDirectoryLayout), {
        queryRef: queryReference,
        isAdminSettingsContext: isAdminSettingsContext
    })));
};
var $2e2a7ebf5ca2a77a$export$2e2bcd8739ae039 = $2e2a7ebf5ca2a77a$var$ProjectsDirectoryContainer;

});
parcelRegister("dpo6O", function(module, exports) {

$parcel$export(module.exports, "ProjectDirectoryLayout", () => $c6eccca01817d954$export$9fc4c60d00e1220);

var $jJiDF = parcelRequire("jJiDF");

var $lVQ0r = parcelRequire("lVQ0r");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");

var $fraBZ = parcelRequire("fraBZ");

var $fc2Kp = parcelRequire("fc2Kp");

var $rq7Hc = parcelRequire("rq7Hc");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $gkT9B = parcelRequire("gkT9B");

var $8pIiT = parcelRequire("8pIiT");

var $88JI2 = parcelRequire("88JI2");

var $5rqex = parcelRequire("5rqex");

var $6VrSE = parcelRequire("6VrSE");

var $9dbF6 = parcelRequire("9dbF6");

var $fhVq7 = parcelRequire("fhVq7");

var $dZw8H = parcelRequire("dZw8H");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $dCm1o = parcelRequire("dCm1o");

var $dPvGX = parcelRequire("dPvGX");

var $he80v = parcelRequire("he80v");

var $hP4DQ = parcelRequire("hP4DQ");

var $jNWQj = parcelRequire("jNWQj");

var $jBriI = parcelRequire("jBriI");

var $4pNZM = parcelRequire("4pNZM");

var $9BDgo = parcelRequire("9BDgo");

var $qB72M = parcelRequire("qB72M");

const $c6eccca01817d954$export$9fc4c60d00e1220 = ({ queryRef: queryRef, isAdminSettingsContext: isAdminSettingsContext })=>{
    const experienceKey = isAdminSettingsContext ? (0, $gkT9B.MANAGE_PROJECTS_DIRECTORY_EXPERIENCE) : (0, $gkT9B.PROJECTS_DIRECTORY_EXPERIENCE);
    const cloudId = (0, $koeKL.useCloudId)();
    const syncQueryFilter = (0, $rq7Hc.useQueryFilter)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experienceKey
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const rootQueryRef = (0, $8Uumt.usePreloadedQuery)((0, $lVQ0r.default), queryRef);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ const [dataRef, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $jJiDF.default), rootQueryRef);
    const prevDataRef = (0, $1XJ20.usePrevious)(dataRef);
    const [{ isFetching: isFetching, errors: errors }, { refetchData: refetchData }] = (0, $fc2Kp.useDirectoryRefetch)({
        refetch: refetch,
        query: (0, $6VrSE.default)
    });
    const handleFilterUpdate = (0, $5uXOq.useCallback)((filter)=>{
        const { [(0, $gkT9B.FilterFields).Page]: currentPage } = filter;
        refetchData({
            variables: {
                cloudId: cloudId,
                filter: (0, $8pIiT.mapQueryToFilter)(filter, {
                    cloudId: cloudId
                }),
                first: (0, $gkT9B.DEFAULT_LIMIT) * parseInt(currentPage, 10),
                last: (0, $gkT9B.DEFAULT_LIMIT),
                isAdminSettingsContext: isAdminSettingsContext
            },
            options: {
                fetchPolicy: 'network-only'
            }
        });
        syncQueryFilter(filter);
    }, [
        cloudId,
        refetchData,
        syncQueryFilter,
        isAdminSettingsContext
    ]);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const canBrowseProjects = isSiteAdmin || isJiraAdmin || rootQueryRef?.jira?.canBrowseProjects?.hasPermission;
    if (!canBrowseProjects) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6eccca01817d954$var$HeaderlessContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4pNZM.AsyncNoPermissionViews), {
        dataRef: rootQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experienceKey,
        attributes: {
            view: 'no-permission'
        }
    }));
    if (errors) {
        onFail('projects-directory-v3.page', errors);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6eccca01817d954$var$HeaderlessContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hP4DQ.PageErrorState), null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "page-layout",
        packageName: "jiraProjectsDirectoryV3",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPvGX.FilterContainer), {
        isGlobal: true,
        onUpdate: handleFilterUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: isAdminSettingsContext ? formatMessage((0, $jBriI.default).adminDocumentTitle) : formatMessage((0, $jBriI.default).documentTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNWQj.Header), {
        dataRef: rootQueryRef,
        isAdminSettingsContext: isAdminSettingsContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qB72M.RefinementBar), {
        dataRef: rootQueryRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhVq7.ScrollablePage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: formatMessage((0, $jBriI.default).filterResultsAnnouncement, {
            itemCount: dataRef?.jira?.allJiraProjects?.totalCount || 0
        }),
        shouldAnnounce: !isFetching && prevDataRef !== dataRef
    }), dataRef?.jira?.allJiraProjects && dataRef?.jira?.allJiraProjects?.totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BDgo.ProjectsList), {
        isLoading: isFetching,
        isAdminSettingsContext: isAdminSettingsContext,
        projectsRef: dataRef?.jira?.allJiraProjects,
        rootQueryRef: rootQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experienceKey,
        attributes: {
            view: 'projects-list'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $he80v.AsyncEmptyView), {
        dataRef: rootQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experienceKey,
        attributes: {
            view: 'empty'
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "projects-directory-v3",
        metricKey: "jira.directories.projects-v3",
        isExpectedToHaveSsr: true // @ts-expect-error - TS2322
        ,
        metric: (0, $88JI2.pageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6eccca01817d954$var$HeaderlessContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qvbgk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jJiDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf9a293684a471b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6003fff2598016aad9b7bcfa4be569a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $6VrSE = parcelRequire("6VrSE");
const $bbf9a293684a471b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "filter"
        },
        {
            "kind": "RootArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        },
        {
            "kind": "RootArgument",
            "name": "last"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $6VrSE.default)
        }
    },
    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "filter"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        },
                        {
                            "kind": "Variable",
                            "name": "last",
                            "variableName": "last"
                        }
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "allJiraProjects",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isAdminSettingsContext",
                                    "variableName": "isAdminSettingsContext"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "projectsList_projectsDirectoryV3_projectsRef"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$bbf9a293684a471b$var$node.hash = "eb5983a7159e6add64de193b1e14a2b6";
var $bbf9a293684a471b$export$2e2bcd8739ae039 = $bbf9a293684a471b$var$node;

});
parcelRegister("6VrSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $146e9aaab261bbcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<583d1f72dc86281f470d2a2197de8611>>
 * @relayHash 103b5514607a80e59b2914a4338f9ab8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95402e6fb90d724bc1ba4923982683b3b9ca3a715ece95644334ae749c563593
const $146e9aaab261bbcb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectDirectoryRefetchQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectDirectoryRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v1 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "queueId"
                                                                }
                                                            ],
                                                            "type": "JiraServiceManagementProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v1 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "95402e6fb90d724bc1ba4923982683b3b9ca3a715ece95644334ae749c563593",
            "metadata": {},
            "name": "ProjectDirectoryRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$146e9aaab261bbcb$var$node.hash = "eb5983a7159e6add64de193b1e14a2b6";
var $146e9aaab261bbcb$export$2e2bcd8739ae039 = $146e9aaab261bbcb$var$node;

});


parcelRegister("fc2Kp", function(module, exports) {

$parcel$export(module.exports, "useDirectoryRefetch", () => $21bc8d8317f54c7d$export$6e338326a9da0df2);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $21bc8d8317f54c7d$export$6e338326a9da0df2 = ({ refetch: refetch, query: query })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const requestInFlight = (0, $5uXOq.useRef)();
    const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
    const [errors, setErrors] = (0, $5uXOq.useState)(null);
    const refetchData = (0, $5uXOq.useCallback)(({ variables: variables, options: options })=>{
        requestInFlight.current?.unsubscribe();
        setIsFetching(true);
        setErrors(null);
        requestInFlight.current = (0, $eiowN.fetchQuery)(environment, query, variables, {
            fetchPolicy: options?.fetchPolicy || 'store-or-network'
        }).subscribe({
            complete: ()=>{
                refetch(variables, {
                    fetchPolicy: 'store-only',
                    onComplete: ()=>{
                        setIsFetching(false);
                        options?.onComplete && options.onComplete();
                    }
                });
            },
            error: (error)=>{
                setIsFetching(false);
                setErrors(error);
                options?.onError && options.onError();
            }
        });
    }, [
        environment,
        query,
        refetch
    ]);
    return [
        {
            isFetching: isFetching,
            errors: errors
        },
        {
            refetchData: refetchData
        }
    ];
};

});

parcelRegister("rq7Hc", function(module, exports) {

$parcel$export(module.exports, "useQueryFilter", () => $4a107a6f2b74163c$export$d0b8acaa70818f20);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $4a107a6f2b74163c$export$d0b8acaa70818f20 = ({ override: override = true } = {})=>{
    const [{ query: query, match: match }, routerActions] = (0, $doZTA.useRouter)();
    const syncQueryFilter = (0, $5uXOq.useCallback)((filter)=>{
        const normalizedFilter = Object.entries(filter).reduce((acc, [key, val])=>{
            if (val) acc[key] = val;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(normalizedFilter, query) && routerActions.replace(`${match.path}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(override ? normalizedFilter : {
            ...query,
            ...normalizedFilter
        })}`);
    }, [
        override,
        match.path,
        query,
        routerActions
    ]);
    return syncQueryFilter;
};

});

parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("88JI2", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $29e6f514c98d2ae6$export$791d520f7e8058a5);
// eslint-disable-next-line jira/import-whitelist

var $dGrdR = parcelRequire("dGrdR");
const $29e6f514c98d2ae6$export$791d520f7e8058a5 = (0, $dGrdR.metrics).pageLoad({
    key: 'projects-directory-v3',
    ssr: {
        doneAsFmp: true
    },
    featureFlags: [
        'projects-directory-entrypoint_sn3p0'
    ]
});

});

parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("fhVq7", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $501f0ba909d41168$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $501f0ba909d41168$export$6d1402fb58384e4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");
const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $501f0ba909d41168$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, children);
const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $501f0ba909d41168$var$scrollablePageStyles = (0, $8CUq3.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("dPvGX", function(module, exports) {

$parcel$export(module.exports, "useScopedFilter", () => $3f2dd45a7998991e$export$c0c3d622c43d72e);
$parcel$export(module.exports, "useFilter", () => $3f2dd45a7998991e$export$3274cf84b703fff);
$parcel$export(module.exports, "FilterContainer", () => $3f2dd45a7998991e$export$2f96f6f204f87534);

var $7OwSg = parcelRequire("7OwSg");

var $dZhZb = parcelRequire("dZhZb");

var $gkT9B = parcelRequire("gkT9B");

var $8pIiT = parcelRequire("8pIiT");
const { useScopedFilter: $3f2dd45a7998991e$export$c0c3d622c43d72e, useFilter: $3f2dd45a7998991e$export$3274cf84b703fff, FilterContainer: $3f2dd45a7998991e$export$2f96f6f204f87534 } = (0, $7OwSg.createUseFilter)('ProjectsDirectoryFilterState', {
    getInitialState: ({ routeQuery: routeQuery })=>(0, $dZhZb.matchAliases)((0, $gkT9B.filterInitialState), (0, $8pIiT.sanitizeLegacyQuery)(routeQuery), (0, $gkT9B.filterAliasMap))
});

});

parcelRegister("he80v", function(module, exports) {

$parcel$export(module.exports, "AsyncEmptyView", () => $723cb9a2d72bf4b7$export$548ce7324e0de587);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $723cb9a2d72bf4b7$var$LazyEmptyView = (0, $kxZPA.lazy)(()=>(parcelRequire("62Bd6")).then(({ EmptyView: EmptyView })=>EmptyView), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/projects-directory-v3/src/ui/page-layout/empty-view/index.tsx"
});
const $723cb9a2d72bf4b7$export$548ce7324e0de587 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "empty-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($723cb9a2d72bf4b7$var$LazyEmptyView, props));

});
parcelRegister("62Bd6", function(module, exports) {

let $465fcb340d8a55e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $465fcb340d8a55e5$var$load("asLLC").then(()=>parcelRequire('f8bcI'));

});


parcelRegister("hP4DQ", function(module, exports) {

$parcel$export(module.exports, "PageErrorState", () => $4c4c6215a1d8edd1$export$93e16ad79580c69);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $koVbs = parcelRequire("koVbs");

var $7cGZT = parcelRequire("7cGZT");
const $4c4c6215a1d8edd1$export$93e16ad79580c69 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const onRetry = (0, $5uXOq.useCallback)(()=>window.location.reload(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $7cGZT.default).header),
        description: formatMessage((0, $7cGZT.default).description),
        onRetry: onRetry
    });
};

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $az4zD = parcelRequire("az4zD");

var $lB1Xg = parcelRequire("lB1Xg");

var $9Le4I = parcelRequire("9Le4I");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($lB1Xg))) : (0, (/*@__PURE__*/$parcel$interopDefault($9Le4I)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("lB1Xg", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("9Le4I", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("7cGZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2b48fa67913631$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c2b48fa67913631$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "projects-directory-v3.page-layout.error-state.header",
        "defaultMessage": "An error occurred"
    },
    description: {
        "id": "projects-directory-v3.page-layout.error-state.description",
        "defaultMessage": "There was a problem loading your projects. Try again or contact your administrator for support."
    }
});

});


parcelRegister("jNWQj", function(module, exports) {

$parcel$export(module.exports, "Header", () => $d000ed073d174a52$export$8b251419efc915eb);

var $90eJM = parcelRequire("90eJM");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $blYup = parcelRequire("blYup");

var $koVbs = parcelRequire("koVbs");

var $cZpsT = parcelRequire("cZpsT");

var $8hZvl = parcelRequire("8hZvl");

var $4OVbb = parcelRequire("4OVbb");

var $hgRkd = parcelRequire("hgRkd");
const $d000ed073d174a52$export$8b251419efc915eb = ({ dataRef: dataRef, isAdminSettingsContext: isAdminSettingsContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jira: jira } = (0, $8Uumt.useFragment)((0, $90eJM.default), dataRef);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blYup.Header), {
        title: isAdminSettingsContext ? formatMessage((0, $4OVbb.default).adminHeaderCaption) : formatMessage((0, $4OVbb.default).headerCaption),
        actions: jira ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hZvl.CreateButton), {
            dataRef: jira
        }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgRkd.OpenTemplatesPanelButton), {
            dataRef: jira
        })) : undefined,
        isAdminSettingsContext: isAdminSettingsContext
    });
};

});
parcelRegister("90eJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6efc2c6f7c108657$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<364beda65bbbc75d8787e30400e03a32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6efc2c6f7c108657$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ],
    "kind": "Fragment",
    "name": "header_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "createProjectAction_projectsDirectoryV3_CreateButton"
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$6efc2c6f7c108657$var$node.hash = "22f237392203128d7ea8a45840fcb1ff";
var $6efc2c6f7c108657$export$2e2bcd8739ae039 = $6efc2c6f7c108657$var$node;

});

parcelRegister("blYup", function(module, exports) {

$parcel$export(module.exports, "Header", () => $63df1a58614137f3$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $26g7Y = parcelRequire("26g7Y");

var $57MwZ = parcelRequire("57MwZ");

var $d8lE2 = parcelRequire("d8lE2");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ca01T = parcelRequire("ca01T");
const $63df1a58614137f3$export$8b251419efc915eb = ({ title: title, actions: actions, children: children, isAdminSettingsContext: isAdminSettingsContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const searchActionLabel = formatMessage((0, $ca01T.default).searchJiraAdmin);
    const { open: open } = (0, $d8lE2.useActionsCommandPalette)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        open();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'searchActionButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dotDialog');
    }, [
        createAnalyticsEvent,
        open
    ]);
    const shifterAction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, actions, isAdminSettingsContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
            label: "",
            LEGACY_size: "small"
        }),
        onClick: onClick
    }, searchActionLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        actions: shifterAction
    }, title), children);
};

});
parcelRegister("ca01T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1835286195bcc1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a1835286195bcc1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchJiraAdmin: {
        "id": "directory-base-v3.header.search-jira-admin",
        "defaultMessage": "Search Jira admin"
    }
});

});


parcelRegister("8hZvl", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $5970b2021bc0982f$export$6d3c345ce7c38fd9);

var $2TaVE = parcelRequire("2TaVE");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $Mp6qH = parcelRequire("Mp6qH");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $e9QkH = parcelRequire("e9QkH");

var $eZZL8 = parcelRequire("eZZL8");
const $5970b2021bc0982f$var$CreateButtonComponent = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        ...props
    }, formatMessage((0, $eZZL8.default).createProject));
};
const $5970b2021bc0982f$var$CreateButton = ({ dataRef: dataRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'directoryHeader'
    });
    const data = (0, $8Uumt.useFragment)((0, $2TaVE.default), dataRef);
    const [, { on: openProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    const handleCreate = (0, $5uXOq.useCallback)(()=>{
        openProjectCreateDrawer();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'CreateProjectButton');
    }, [
        analyticsEvent,
        openProjectCreateDrawer
    ]);
    if (!data?.canCreateProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5970b2021bc0982f$var$CreateButtonComponent, {
        "data-testId": "global-pages.directories.projects-directory-v3.create-projects-button",
        onClick: handleCreate
    });
};
const $5970b2021bc0982f$export$6d3c345ce7c38fd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "create-project-button",
        packageName: "jira-project-directory-page-v3",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5970b2021bc0982f$var$CreateButton, props));

});
parcelRegister("2TaVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $54793390d1738743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f341e321a1687a6141d269c751cf0a0f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54793390d1738743$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "createProjectAction_projectsDirectoryV3_CreateButton",
    "selections": [
        {
            "alias": "canCreateProject",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "CREATE_PROJECT"
                }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ],
    "type": "JiraQuery"
};
$54793390d1738743$var$node.hash = "df6f22d032f8d63a59ac7ad12bb1116f";
var $54793390d1738743$export$2e2bcd8739ae039 = $54793390d1738743$var$node;

});

parcelRegister("eZZL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c4919d55f32747$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1c4919d55f32747$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProject: {
        "id": "projects-directory-v3.page-layout.header.create-project-action.create-project",
        "defaultMessage": "Create project"
    }
});

});


parcelRegister("4OVbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $145fd049ccb4af48$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $145fd049ccb4af48$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    headerCaption: {
        "id": "projects-directory-v3.page-layout.header.header-caption",
        "defaultMessage": "Projects"
    },
    adminHeaderCaption: {
        "id": "projects-directory-v3.page-layout.header.admin-header-caption",
        "defaultMessage": "Manage Projects"
    }
});

});

parcelRegister("hgRkd", function(module, exports) {

$parcel$export(module.exports, "OpenTemplatesPanelButton", () => $f7017a5cc5dfe719$export$6ac7df8c3bce770);

var $cSfZu = parcelRequire("cSfZu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $b8A8x = parcelRequire("b8A8x");

var $g0buz = parcelRequire("g0buz");

var $a49ag = parcelRequire("a49ag");
const $f7017a5cc5dfe719$var$OpenTemplatesPanelButton = ({ dataRef: dataRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'directoryHeader'
    });
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { canCreateProject: canCreateProject, userPreferences: userPreferences, sidebarExperimentTemplates: sidebarExperimentTemplates } = (0, $8Uumt.useFragment)((0, $cSfZu.default), dataRef);
    const setProjectListRightPanelState = (0, $g0buz.useSetProjectListRightPanelState)(userPreferences.__id);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openTemplatesPanelButton');
        if (userPreferences.projectListRightPanelState === 'OPEN' && rightSidebarCurrentState?.panelId !== (0, $b8A8x.PANEL_ID)) {
            openRightSidebar((0, $b8A8x.PANEL_ID), (0, $b8A8x.SIDEBAR_WIDTH), false, true);
            return;
        }
        setProjectListRightPanelState(userPreferences.projectListRightPanelState === 'OPEN' ? 'CLOSED' : 'OPEN');
    }, [
        analyticsEvent,
        openRightSidebar,
        rightSidebarCurrentState?.panelId,
        setProjectListRightPanelState,
        userPreferences.projectListRightPanelState
    ]);
    if (!canCreateProject || typeof sidebarExperimentTemplates?.totalCount !== 'number' || sidebarExperimentTemplates.totalCount === 0) {
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'openTemplatesPanelButton skipped', {
            reason: 'sidebarEligibility failed',
            canCreateProject: canCreateProject,
            totalCount: sidebarExperimentTemplates.totalCount
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "data-testId": "global-pages.directories.projects-directory-v3.templates-panel-button",
        isSelected: rightSidebarCurrentState?.panelId === (0, $b8A8x.PANEL_ID),
        onClick: onClick
    }, formatMessage((0, $a49ag.default).templatesButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            experiment: 'recommendationsinProjectsDirectoryWithHoverPreview',
            totalCount: sidebarExperimentTemplates.totalCount,
            canCreateProject: canCreateProject
        }
    }));
};
const $f7017a5cc5dfe719$export$6ac7df8c3bce770 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "open-templates-panel-button",
        packageName: "jiraProjectsDirectoryV3",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "projectsV3",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f7017a5cc5dfe719$var$OpenTemplatesPanelButton, props)));

});
parcelRegister("cSfZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df339b0a0a1d4f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c09f58b52b9291556cc0880556a04178>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4df339b0a0a1d4f4$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton",
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        v0 /*: any*/ 
                    ],
                    "concreteType": "JiraUserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "projectListRightPanelState"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "userPreferences"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "sidebarExperimentTemplates",
                    "args": [
                        v0 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "experimentKey",
                            "value": "sidebarExperiment"
                        }
                    ],
                    "concreteType": "JiraProjectListViewTemplateConnection",
                    "kind": "LinkedField",
                    "name": "projectListViewTemplates",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "sidebarExperimentTemplates.totalCount"
                        }
                    ]
                },
                "action": "THROW",
                "path": "sidebarExperimentTemplates"
            }
        ],
        "type": "JiraQuery"
    };
}();
$4df339b0a0a1d4f4$var$node.hash = "57f9e2bfda0bc31526f57df7eb39fcad";
var $4df339b0a0a1d4f4$export$2e2bcd8739ae039 = $4df339b0a0a1d4f4$var$node;

});

parcelRegister("b8A8x", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $a27b9c5e490bee8d$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_WIDTH_REFRESH", () => $a27b9c5e490bee8d$export$a191a221249cbcae);
$parcel$export(module.exports, "PANEL_ID", () => $a27b9c5e490bee8d$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PROJECT_CREATE_SOURCE", () => $a27b9c5e490bee8d$export$280536374592bda3);
$parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", () => $a27b9c5e490bee8d$export$990484f4e8c06c90);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $a27b9c5e490bee8d$export$29629758934356a6);

var $jWY5k = parcelRequire("jWY5k");

var $iDfVE = parcelRequire("iDfVE");
const $a27b9c5e490bee8d$export$780035d9fe48eb32 = 365;
const $a27b9c5e490bee8d$export$a191a221249cbcae = 400;
const $a27b9c5e490bee8d$export$e1d562d81d0e502d = 'recommendationsInProjectList';
const $a27b9c5e490bee8d$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
const $a27b9c5e490bee8d$export$280536374592bda3 = 'recommendationsInProjectList';
const $a27b9c5e490bee8d$export$990484f4e8c06c90 = {
    BUSINESS: (0, $jWY5k.Targets).JIRA_CORE,
    SOFTWARE: (0, $jWY5k.Targets).JIRA_SOFTWARE,
    SERVICE_DESK: (0, $jWY5k.Targets).JIRA_SERVICE_DESK,
    PRODUCT_DISCOVERY: (0, $jWY5k.Targets).JIRA_PRODUCT_DISCOVERY
};
const $a27b9c5e490bee8d$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("g0buz", function(module, exports) {

$parcel$export(module.exports, "useSetProjectListRightPanelState", () => $3d92352d561501b7$export$f7872413c3847449);

var $5pqbm = parcelRequire("5pqbm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");
const $3d92352d561501b7$var$PROJECT_LIST_RIGHT_PANEL_STATE = 'projectListRightPanelState';
const $3d92352d561501b7$var$relayStoreUpdater = (store, userPreferencesRefId, state)=>{
    if (typeof userPreferencesRefId === 'string') {
        const record = store.get(userPreferencesRefId);
        record?.setValue(state, $3d92352d561501b7$var$PROJECT_LIST_RIGHT_PANEL_STATE);
    }
};
const $3d92352d561501b7$export$f7872413c3847449 = (userPreferencesRefId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $5pqbm.default));
    const setRightPanelState = (0, $5uXOq.useCallback)((state)=>{
        commit({
            variables: {
                cloudId: cloudId,
                state: state
            },
            optimisticUpdater: (store)=>$3d92352d561501b7$var$relayStoreUpdater(store, userPreferencesRefId, state),
            updater: (store, { // @ts-expect-error TS-2339 - Property 'jira' does not exist on type 'setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation$data | null | undefined'.
            jira: { userPreferences: { setProjectListRightPanelState: { projectListRightPanelState: projectListRightPanelState } } } })=>$3d92352d561501b7$var$relayStoreUpdater(store, userPreferencesRefId, projectListRightPanelState ?? state),
            onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'userPreferences' does not exist on type '{ readonly userPreferences: { readonly setProjectListRightPanelState: { readonly errors: readonly { readonly extensions: { readonly statusCode: number | null | undefined; } | null | undefined; readonly message: string | null | undefined; }[] | null | undefined; readonly projectListRightPanelState: JiraProjectListRig...'.
            userPreferences: { setProjectListRightPanelState: { success: success, errors: errors } } } })=>{
                const error = (errors ?? [])[0];
                if (!success || error) {
                    const errorMessage = `error on set project list right panel state: ${error.message}`;
                    const statusCode = error.extensions?.statusCode;
                    (0, $jcw0u.default)({
                        error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                        meta: {
                            id: 'jiraSetProjectListRightPanelStateError',
                            packageName: 'jiraGrowthRecommendationsInProjectList'
                        }
                    });
                }
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    error: new Error(`jiraSetProjectListRightPanelStateMutationError with ${error.message}`),
                    meta: {
                        id: 'jiraSetProjectListRightPanelStateMutationError',
                        packageName: 'jiraGrowthRecommendationsInProjectList'
                    }
                });
            }
        });
    }, [
        cloudId,
        commit,
        userPreferencesRefId
    ]);
    return setRightPanelState;
};

});
parcelRegister("5pqbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa907682b1711b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f982c84219e38d14c162a90f7e73d838>>
 * @relayHash 932a6ab30b4abea8c4b298d0299ba01a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b
const $faa907682b1711b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b",
            "metadata": {},
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$faa907682b1711b4$var$node.hash = "1cbcdd010c06eb6470327729729fba37";
var $faa907682b1711b4$export$2e2bcd8739ae039 = $faa907682b1711b4$var$node;

});


parcelRegister("a49ag", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca80a8d0ed79712d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ca80a8d0ed79712d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    templatesButton: {
        "id": "projects-directory-v3.page-layout.header.open-templates-panel.templates-button",
        "defaultMessage": "Templates"
    }
});

});



parcelRegister("jBriI", function(module, exports) {

$parcel$export(module.exports, "default", () => $23ed3a75ab32d9bb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $23ed3a75ab32d9bb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    documentTitle: {
        "id": "projects-directory-v3.page-layout.document-title",
        "defaultMessage": "Projects"
    },
    adminDocumentTitle: {
        "id": "projects-directory-v3.page-layout.admin-document-title",
        "defaultMessage": "Manage Projects"
    },
    filterResultsAnnouncement: {
        "id": "projects-directory-v3.page-layout.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No projects were found that match your search} one {{itemCount} project found} other {{itemCount} projects found}}"
    }
});

});

parcelRegister("4pNZM", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPermissionViews", () => $2aa9ba258e3b4c1b$export$a2f35d77f8a7c2df);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2aa9ba258e3b4c1b$var$LazyNoPermissionViews = (0, $kxZPA.lazy)(()=>(parcelRequire("2DUBP")).then(({ NoPermissionViews: NoPermissionViews })=>NoPermissionViews), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/projects-directory-v3/src/ui/page-layout/no-permission-views/index.tsx"
});
const $2aa9ba258e3b4c1b$export$a2f35d77f8a7c2df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-permission-views",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2aa9ba258e3b4c1b$var$LazyNoPermissionViews, props));

});
parcelRegister("2DUBP", function(module, exports) {

let $1ecb22b31141179d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ecb22b31141179d$var$load("4g5mM").then(()=>parcelRequire('cwinS'));

});


parcelRegister("9BDgo", function(module, exports) {

$parcel$export(module.exports, "ProjectsList", () => $2f30cecb5e68f7b0$export$99bffacbdbcb5195);

var $10mZH = parcelRequire("10mZH");

var $012oV = parcelRequire("012oV");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $23EKX = parcelRequire("23EKX");

var $jCHzE = parcelRequire("jCHzE");
const $2f30cecb5e68f7b0$export$99bffacbdbcb5195 = ({ projectsRef: projectsRef, rootQueryRef: rootQueryRef, isLoading: isLoading, isAdminSettingsContext: isAdminSettingsContext })=>{
    const dataRef = (0, $8Uumt.useFragment)((0, $012oV.default), projectsRef);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const categoriesData = (0, $8Uumt.useFragment)((0, $10mZH.default), rootQueryRef);
    const shouldShowCategories = (0, $5uXOq.useMemo)(()=>Boolean(categoriesData.jira?.allJiraProjectCategories?.edges?.length), [
        categoriesData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f30cecb5e68f7b0$var$Container, {
        isLoading: isLoading,
        "data-testid": "global-pages.directories.projects-directory-v3.ui.page-layout.projects-list.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jCHzE.ResultsTable), {
        shouldShowCategories: shouldShowCategories,
        projectsRef: dataRef,
        jiraQueryRef: categoriesData.jira || null,
        isAdminSettingsContext: isAdminSettingsContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23EKX.Pagination), {
        projectsRef: dataRef
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f30cecb5e68f7b0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _n3tdpxbi _aetrb3bt _18postnw _z0ai1osq _1qdg1osq _1hfk1bhr _15l2idpf _19doidpf",
            __cmplp.isLoading ? "_1ywu1ule" : "_1ywuglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("10mZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f03a9149749c57$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00f1382389e8ddfb70ece3b8fdc2d637>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d0f03a9149749c57$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isAnonymous"
            }
        ],
        "kind": "Fragment",
        "name": "projectsList_projectsDirectoryV3_rootQueryRef",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAnonymous",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": v0 /*: any*/ ,
                                "concreteType": "JiraProjectCategoryConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjectCategories",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectCategoryEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": v0 /*: any*/ ,
                        "kind": "FragmentSpread",
                        "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$d0f03a9149749c57$var$node.hash = "17861eb1411077bef688cc2747a1321b";
var $d0f03a9149749c57$export$2e2bcd8739ae039 = $d0f03a9149749c57$var$node;

});

parcelRegister("012oV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3bc3d78dad75f9b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c7c638034af1606cfc66ad7c0873876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3bc3d78dad75f9b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }
    ],
    "kind": "Fragment",
    "name": "projectsList_projectsDirectoryV3_projectsRef",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isAdminSettingsContext",
                    "variableName": "isAdminSettingsContext"
                }
            ],
            "kind": "FragmentSpread",
            "name": "resultsTable_projectsDirectoryV3"
        },
        {
            "kind": "FragmentSpread",
            "name": "pagination_projectsDirectoryV3"
        }
    ],
    "type": "JiraProjectConnection"
};
$d3bc3d78dad75f9b$var$node.hash = "a2ac4e53b4aeb7f1a30eaf9175bfdeae";
var $d3bc3d78dad75f9b$export$2e2bcd8739ae039 = $d3bc3d78dad75f9b$var$node;

});

parcelRegister("23EKX", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => $d7b0791bcfaedb14$export$68f5e1453c188a82);

var $29id7 = parcelRequire("29id7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kgoHi = parcelRequire("kgoHi");

var $l7W0s = parcelRequire("l7W0s");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gkT9B = parcelRequire("gkT9B");

var $dCm1o = parcelRequire("dCm1o");

var $dPvGX = parcelRequire("dPvGX");
const $d7b0791bcfaedb14$export$68f5e1453c188a82 = ({ projectsRef: projectsRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'resultsTable'
    });
    const [value, { updateFilter: updateFilter }] = (0, $dPvGX.useScopedFilter)((0, $gkT9B.FilterFields).Page);
    const currentPage = parseInt(value, 10);
    const dataRef = (0, $8Uumt.useFragment)((0, $29id7.default), projectsRef);
    const handleChange = (0, $5uXOq.useCallback)((page)=>{
        updateFilter((0, $gkT9B.FilterFields).Page, page.toString());
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'PageNumber');
    }, [
        analyticsEvent,
        updateFilter
    ]);
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7W0s.Pagination), {
        dataRef: dataRef,
        itemsPerPage: (0, $gkT9B.DEFAULT_LIMIT),
        currentPage: currentPage,
        onChange: handleChange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7W0s.Pagination), {
        dataRef: dataRef,
        itemsPerPage: (0, $gkT9B.DEFAULT_LIMIT),
        currentPage: currentPage,
        onChange: handleChange
    });
};

});
parcelRegister("29id7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc77703b4d9ebb06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<278a452adea7689a9e2551bcd4ee9f68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc77703b4d9ebb06$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "pagination_projectsDirectoryV3",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "pagination_directoryBaseV3"
        }
    ],
    "type": "JiraProjectConnection"
};
$fc77703b4d9ebb06$var$node.hash = "ab05e4ef735cb6b0a98b29d30007a5ef";
var $fc77703b4d9ebb06$export$2e2bcd8739ae039 = $fc77703b4d9ebb06$var$node;

});

parcelRegister("l7W0s", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => $479573a11f152c22$export$68f5e1453c188a82);

var $6f0MA = parcelRequire("6f0MA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $xBgAj = parcelRequire("xBgAj");

var $koVbs = parcelRequire("koVbs");

var $7VJSW = parcelRequire("7VJSW");
const $479573a11f152c22$var$PAGES_TO_DISPLAY = 10;
const $479573a11f152c22$export$68f5e1453c188a82 = ({ dataRef: dataRef, itemsPerPage: itemsPerPage, currentPage: currentPage, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { totalCount: totalCount } = (0, $8Uumt.useFragment)((0, $6f0MA.default), dataRef);
    const handlePageChange = (0, $5uXOq.useCallback)((_, page)=>{
        onChange(page);
    }, [
        onChange
    ]);
    const pages = (0, $5uXOq.useMemo)(()=>{
        if (!totalCount) return [];
        const totalPages = Math.ceil(totalCount / itemsPerPage);
        const middle = [];
        const end = Math.min(currentPage + $479573a11f152c22$var$PAGES_TO_DISPLAY, totalPages);
        const start = Math.max(currentPage - $479573a11f152c22$var$PAGES_TO_DISPLAY, 1);
        for(let i = start; i < end; i += 1)middle.push(i);
        return Array.from(new Set([
            1,
            ...middle,
            totalPages
        ]));
    }, [
        totalCount,
        itemsPerPage,
        currentPage
    ]);
    const selectedIndex = (0, $5uXOq.useMemo)(()=>pages.findIndex((p)=>p === currentPage), [
        pages,
        currentPage
    ]);
    if (!totalCount) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
        pages: pages,
        onChange: handlePageChange,
        selectedIndex: selectedIndex,
        nextLabel: formatMessage((0, $7VJSW.default).next),
        previousLabel: formatMessage((0, $7VJSW.default).previous)
    });
};

});
parcelRegister("6f0MA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed9309e8fbf8b95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c2e64beddc9c311d09d56ae5eaf9bcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ed9309e8fbf8b95$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "pagination_directoryBaseV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ],
    "type": "HasTotal",
    "abstractKey": "__isHasTotal"
};
$8ed9309e8fbf8b95$var$node.hash = "38583de0cf0e75e654e4970a8d336719";
var $8ed9309e8fbf8b95$export$2e2bcd8739ae039 = $8ed9309e8fbf8b95$var$node;

});

parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});


parcelRegister("7VJSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f76bb650b37806f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f76bb650b37806f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    next: {
        "id": "pagination.next",
        "defaultMessage": "Next page"
    },
    previous: {
        "id": "pagination.previous",
        "defaultMessage": "Previous page"
    }
});

});



parcelRegister("jCHzE", function(module, exports) {

$parcel$export(module.exports, "ResultsTable", () => $373842dac8dd0b01$export$cd4354c9a18aa0b5);

var $bo0Ax = parcelRequire("bo0Ax");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gkT9B = parcelRequire("gkT9B");

var $3ixDM = parcelRequire("3ixDM");

var $cZpsT = parcelRequire("cZpsT");

var $dPvGX = parcelRequire("dPvGX");

var $gxECQ = parcelRequire("gxECQ");

var $1Mh8b = parcelRequire("1Mh8b");

var $6KK5t = parcelRequire("6KK5t");
const $373842dac8dd0b01$export$cd4354c9a18aa0b5 = ({ shouldShowCategories: shouldShowCategories, projectsRef: projectsRef, jiraQueryRef: jiraQueryRef, isAdminSettingsContext: isAdminSettingsContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'resultsTable'
    });
    const [filter, { updateFilter: updateFilter }] = (0, $dPvGX.useFilter)();
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const projects = (0, $8Uumt.useFragment)((0, $bo0Ax.default), projectsRef);
    const head = (0, $5uXOq.useMemo)(()=>(0, $1Mh8b.getTableHeader)({
            formatMessage: formatMessage,
            isAnonymous: isAnonymous,
            shouldShowCategories: shouldShowCategories,
            isAdminSettingsContext: isAdminSettingsContext
        }), [
        formatMessage,
        isAnonymous,
        shouldShowCategories,
        isAdminSettingsContext
    ]);
    const projectsItems = (0, $5uXOq.useMemo)(()=>{
        const totalCount = projects?.totalCount || 0;
        return projects?.pageInfo?.hasNextPage ? projects?.edges : projects?.edges?.slice(totalCount % (0, $gkT9B.DEFAULT_LIMIT) * -1);
    }, [
        projects?.edges,
        projects?.pageInfo?.hasNextPage,
        projects?.totalCount
    ]);
    const rows = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        projectsItems?.map((project)=>project && (0, $6KK5t.getTableRow)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            project.node, isAdminSettingsContext, jiraQueryRef)).filter(Boolean), [
        projectsItems,
        isAdminSettingsContext,
        jiraQueryRef
    ]);
    const handleSort = (0, $5uXOq.useCallback)(({ key: key, sortOrder: sortOrder })=>{
        updateFilter({
            [(0, $gkT9B.FilterFields).SortOrder]: sortOrder,
            [(0, $gkT9B.FilterFields).SortKey]: key
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'SortOrder', {
            sortOrder: sortOrder,
            sortKey: key
        });
    }, [
        analyticsEvent,
        updateFilter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // This change has been added to resolve https://jplat.atlassian.net/browse/BLU-4931
        handleSort({
            key: filter[(0, $gkT9B.FilterFields).SortKey],
            // This suppression is consistent with existing code when the fix was added
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sortOrder: filter[(0, $gkT9B.FilterFields).SortOrder]
        });
    // We just want this to run once on component mount, so we don't need to add `filter` to the dependencies
    // Which is why we're suppressing the warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getCaptionText = ()=>{
        const selectedProductsKeys = filter[(0, $gkT9B.FilterFields).ProjectType]?.split(',').filter(Boolean) || [];
        const selectedProjectCategory = filter[(0, $gkT9B.FilterFields).ProjectCategoryLabel];
        const selectedProductsLabels = filter[(0, $gkT9B.FilterFields).ProjectTypeLabel];
        if (!selectedProductsKeys.length) {
            if (!shouldShowCategories) return formatMessage((0, $gxECQ.default).tableCaptionAllProjects);
            if (!selectedProjectCategory) return formatMessage((0, $gxECQ.default).tableCaptionAllProjectsAndAllCategories);
            return formatMessage((0, $gxECQ.default).tableCaptionSpecificCategory, {
                category: selectedProjectCategory
            });
        }
        if (!shouldShowCategories) return formatMessage((0, $gxECQ.default).tableCaptionSpecificProduct, {
            product: selectedProductsLabels
        });
        if (!selectedProjectCategory) return formatMessage((0, $gxECQ.default).tableCaptionSpecificProductAllCategories, {
            product: selectedProductsLabels
        });
        return formatMessage((0, $gxECQ.default).tableCaptionSpecificProductSpecificCategories, {
            product: selectedProductsLabels,
            category: selectedProjectCategory
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ixDM.SimpleTable), {
        captionText: getCaptionText(),
        head: head,
        rows: rows,
        sortKey: filter[(0, $gkT9B.FilterFields).SortKey],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortOrder: filter[(0, $gkT9B.FilterFields).SortOrder],
        onSort: handleSort
    });
};

});
parcelRegister("bo0Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $965de2b3474cfb1d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7df0b3b5b48dae9d5693144b33eee9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $965de2b3474cfb1d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }
    ],
    "kind": "Fragment",
    "name": "resultsTable_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "favouriteCell_projectsDirectoryV3_FavoriteCell"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "nameCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "keyCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectTypeCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectCategoryCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "leadCell_projectsDirectoryV3"
                        },
                        {
                            "condition": "isAdminSettingsContext",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "lastIssueUpdateCell_projectsDirectoryV3"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "urlCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "actionsCell_projectsDirectoryV3_project"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalCount"
        },
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }
    ],
    "type": "JiraProjectConnection"
};
$965de2b3474cfb1d$var$node.hash = "9ed13593445dfde5eabe8be75addbd2e";
var $965de2b3474cfb1d$export$2e2bcd8739ae039 = $965de2b3474cfb1d$var$node;

});

parcelRegister("3ixDM", function(module, exports) {

$parcel$export(module.exports, "SimpleTable", () => $d3d0fb3942243d15$export$3fe48f9151d0ecc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $lITuv = parcelRequire("lITuv");

var $6i8tl = parcelRequire("6i8tl");

var $1y0Lu = parcelRequire("1y0Lu");

var $aK8yz = parcelRequire("aK8yz");
const $d3d0fb3942243d15$export$3fe48f9151d0ecc2 = ({ head: head, rows: rows, sortKey: sortKey, sortOrder: sortOrder, onSort: onSort, captionText: captionText })=>{
    const columnKeys = (0, $5uXOq.useMemo)(()=>head.cells.map((cell)=>cell.key), [
        head
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const alertMessage = sortOrder === (0, $6i8tl.SortOrder).ASC ? (0, $lITuv.default).srOnlySortingAlertAsc : (0, $lITuv.default).srOnlySortingAlertDesc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3d0fb3942243d15$export$54ec01a60f47d33d, null, captionText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3d0fb3942243d15$var$SrOnlyCaption, null, captionText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3d0fb3942243d15$var$SrOnlyCaption, null, formatMessage((0, $lITuv.default).srOnlyCaption), sortOrder && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-live": "polite",
        "aria-relevant": "text"
    }, formatMessage(alertMessage, {
        sortKey: sortKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1y0Lu.TableHead), {
        onSort: onSort,
        ...head,
        sortKey: sortKey,
        sortOrder: sortOrder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", null, rows.map((rowProps, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aK8yz.TableRow), {
            isLastRow: (0, $dCm1o.isVisualRefreshEnabled)() ? index === rows.length - 1 : false,
            columnKeys: columnKeys,
            ...rowProps,
            key: `table-row-${index}`
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3d0fb3942243d15$var$TableOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yq5hcfaq _1bsb1osq _1kqm1n9t _19pkidpf _2hwxidpf _otyr1ejb _18u0idpf",
            __cmplp.className
        ])
    });
});
const $d3d0fb3942243d15$export$54ec01a60f47d33d = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "table",
        xcss: $d3d0fb3942243d15$var$tableStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3d0fb3942243d15$var$TableOld, null, children));
const $d3d0fb3942243d15$var$tableStyles = (0, $8CUq3.xcss)({
    width: '100%',
    tableLayout: 'fixed',
    margin: 'space.0',
    marginBottom: 'space.300',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'border.radius.200',
    borderCollapse: 'separate',
    borderSpacing: 0,
    overflow: 'hidden'
});
const $d3d0fb3942243d15$var$srOnlyStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d3d0fb3942243d15$var$SrOnlyCaption = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswstnw _154i1wug _ogto7mnp _1bsbt94y _4t3it94y _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lITuv", function(module, exports) {

$parcel$export(module.exports, "default", () => $52289dd44420c4f5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52289dd44420c4f5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    srOnlyCaption: {
        "id": "simple-table.sr-only-caption",
        "defaultMessage": "Use column header buttons to sort"
    },
    srOnlySortingAlertAsc: {
        "id": "simple-table.sr-only-sorting-alert-asc",
        "defaultMessage": "{sortKey} column is sorted by ascending order"
    },
    srOnlySortingAlertDesc: {
        "id": "simple-table.sr-only-sorting-alert-desc",
        "defaultMessage": "{sortKey} column is sorted by descending order"
    }
});

});

parcelRegister("6i8tl", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $826aa536310f15bc$export$7ae723045d45777a);
$parcel$export(module.exports, "SortOrderLabel", () => $826aa536310f15bc$export$6123155563a1925);
const $826aa536310f15bc$export$7ae723045d45777a = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $826aa536310f15bc$export$6123155563a1925 = {
    ASC: 'ascending',
    DESC: 'descending'
};

});

parcelRegister("1y0Lu", function(module, exports) {

$parcel$export(module.exports, "TableHead", () => $3109ad13e80c3b31$export$2f4a7be4f0dcc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $dkGRB = parcelRequire("dkGRB");
const $3109ad13e80c3b31$export$2f4a7be4f0dcc2 = ({ cells: cells, sortOrder: sortOrder, sortKey: sortKey, onSort: onSort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3109ad13e80c3b31$export$686fc6781ca5e30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3109ad13e80c3b31$export$2ed37f428538a29e, null, cells.map((headCell)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkGRB.HeadCell), {
            ...headCell,
            key: headCell.key,
            onSort: onSort,
            sortOrder: sortOrder,
            sortKey: sortKey,
            cellKey: headCell.key
        }))));
const $3109ad13e80c3b31$var$SortIconContainerSelector = 'simple-table-sort-icon-container';
const $3109ad13e80c3b31$var$SortableIconCellContentWrapperSelector = 'simple-table-sortable-icon-cell-content-wrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3109ad13e80c3b31$var$TableHeadContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _1r04idpf _s7n4nkob _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3109ad13e80c3b31$export$686fc6781ca5e30 = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "thead",
        xcss: $3109ad13e80c3b31$var$tableHeadStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3109ad13e80c3b31$var$TableHeadContainerOld, null, children));
const $3109ad13e80c3b31$var$tableHeadStyles = (0, $8CUq3.xcss)({
    verticalAlign: 'middle',
    inset: 'space.0',
    position: 'relative',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.200',
    height: 'space.500'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3109ad13e80c3b31$var$TableHeadRowContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189e18uv _1dqoglyw _1h6d18uv _4t3i14no _10dk105o _bd0s105o _aswu1b66 _d1ad1b66 _174iidpf _1thxidpf",
            __cmplp.className
        ])
    });
});
const $3109ad13e80c3b31$export$2ed37f428538a29e = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "tr"
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3109ad13e80c3b31$var$TableHeadRowContainerOld, null, children));

});
parcelRegister("dkGRB", function(module, exports) {

$parcel$export(module.exports, "HeadCell", () => $cb5bbd562c0ca574$export$4e8024263ace498b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $588G7 = parcelRequire("588G7");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $6i8tl = parcelRequire("6i8tl");

var $2XBKO = parcelRequire("2XBKO");
const $cb5bbd562c0ca574$var$TooltipContent = ({ children: children, sortOrder: sortOrder })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$TooltipContentWrapper, null, children, " \u2022", ' ', formatMessage(sortOrder === (0, $6i8tl.SortOrder).ASC ? (0, $2XBKO.default).tooltipAscSortingDirectionContent : (0, $2XBKO.default).tooltipDescSortingDirectionContent));
};
const $cb5bbd562c0ca574$var$TooltipWrapper = ({ tooltipContent: tooltipContent, content: content, sortOrder: sortOrder, children: children })=>{
    if (false) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$TooltipContent, {
            sortOrder: sortOrder
        }, content),
        position: "top"
    }, children);
};
const $cb5bbd562c0ca574$export$1c3e7abe01fad210 = 'simple-table-sortable-icon-cell-content-wrapper';
const $cb5bbd562c0ca574$export$4e8024263ace498b = ({ isSortable: isSortable, cellKey: cellKey, content: content, sortKey: sortKey, sortOrder: sortOrder, tooltipContent: tooltipContent, onSort: onSort, width: width, textAlign: textAlign, isIconColumn: isIconColumn, element: element })=>{
    const isActive = cellKey === sortKey;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)(()=>onSort({
            key: cellKey,
            sortOrder: isActive && sortOrder === (0, $6i8tl.SortOrder).ASC ? (0, $6i8tl.SortOrder).DESC : (0, $6i8tl.SortOrder).ASC
        }), [
        cellKey,
        sortOrder,
        onSort,
        isActive
    ]);
    let sortableValue;
    if (isSortable) {
        sortableValue = 'none';
        if (isActive && sortOrder) sortableValue = (0, $6i8tl.SortOrderLabel)[sortOrder];
    }
    const buttonProperties = {
        'aria-roledescription': isSortable ? formatMessage((0, $2XBKO.default).a11YSortButtonDescriptionLabel) : undefined
    };
    const wrappedContent = isIconColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$IconCellContentWrapper, {
        "data-component-selector": isSortable ? $cb5bbd562c0ca574$export$1c3e7abe01fad210 : '',
        isSortable: isSortable,
        isActive: isActive
    }, content) : content;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$HeadCellContainer, {
        as: element,
        isSortable: isSortable,
        width: width,
        "aria-sort": sortableValue,
        textAlign: textAlign,
        isIconColumn: isIconColumn
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$TooltipWrapper, {
        tooltipContent: tooltipContent,
        content: content,
        sortOrder: sortOrder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$SortHeadCellContainer, {
        width: width,
        isActive: isActive,
        onClick: handleClick,
        isIconColumn: isIconColumn,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        ...buttonProperties
    }, wrappedContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb5bbd562c0ca574$var$SortIconContainer, {
        isActive: isActive,
        sortOrder: sortOrder,
        isIconColumn: isIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($588G7))), {
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    })))) : wrappedContent);
};
const $cb5bbd562c0ca574$var$SortIconContainerSelector = 'simple-table-sort-icon-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb5bbd562c0ca574$var$SortIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isIconColumn: isIconColumn, sortOrder: sortOrder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641b4w",
            __cmplp.isActive ? "_tzy4zg3v" : "_tzy4idpf",
            __cmplp.isActive || __cmplp.isIconColumn ? "_18u01b66" : "_18u0idpf",
            __cmplp.isIconColumn ? "_2hwx1b66" : "_2hwxidpf",
            __cmplp.sortOrder === (0, $6i8tl.SortOrder).DESC ? "_t9ec1sub" : "_t9ecglyw",
            __cmplp.className
        ])
    });
});
$cb5bbd562c0ca574$var$SortIconContainer.defaultProps = {
    'data-component-selector': $cb5bbd562c0ca574$var$SortIconContainerSelector
};
const $cb5bbd562c0ca574$var$IconCellContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSortable: isSortable, isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564wz4i _154i1ssb _1ltv1ssb",
            __cmplp.isSortable ? "_kqswstnw" : "_kqswn7od",
            __cmplp.isActive ? "_tzy4grf3" : "_tzy4kb7n",
            __cmplp.isSortable ? "_t9ec1ooe" : "_t9ecglyw",
            __cmplp.className
        ])
    });
});
const $cb5bbd562c0ca574$var$HeadCellContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSortable: isSortable, isIconColumn: isIconColumn, textAlign: textAlign, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "%"),
            "--_1tpx2gk": (0, $lD23V.default)(__cmplp.textAlign)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5pio18uv _11c82smr _1h6d18uv _1dqoglyw _189e18uv _1e0cdav6 _kqswh2mm _r06hglyw _s7n4nkob _vchhusvi _k48p1wq8 _syaz1fxt _1tesidpf _1cs8stnw _txdo12hm _1kt9b3bt _dsq4glyw _19woidpf _1aukidpf",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_19bvidpf" : "_19bvu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_u5f3idpf" : "_u5f3u2gc",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            __cmplp.textAlign && "_y3gnp1rm",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1lhcidpf" : "_1lhcu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1o59idpf" : "_1o59u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb5bbd562c0ca574$var$HeadCellContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSortable: isSortable, isIconColumn: isIconColumn, textAlign: textAlign, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "%"),
            "--_1tpx2gk": (0, $lD23V.default)(__cmplp.textAlign)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5pio18uv _11c81vhk _1h6d18uv _1dqoglyw _189e18uv _n7zlzgxb _1e0cdav6 _kqswh2mm _r06hglyw _s7n4nkob _vchhusvi _syaz1gjq _10dk105o _bd0s105o _aswu1b66 _d1ad1b66 _174iidpf _1thxidpf",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_19bvidpf" : "_19bvu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_u5f3idpf" : "_u5f3u2gc",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            __cmplp.textAlign && "_y3gnp1rm",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1lhcidpf" : "_1lhcu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1o59idpf" : "_1o59u2gc",
            __cmplp.className
        ])
    });
});
const $cb5bbd562c0ca574$var$HeadCellContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $cb5bbd562c0ca574$var$HeadCellContainerNew, $cb5bbd562c0ca574$var$HeadCellContainerOld);
const $cb5bbd562c0ca574$var$SortHeadCellContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconColumn: isIconColumn, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_tsntec": (0, $lD23V.default)(`${"var(--ds-space-050, 4px)"} ${__cmplp.isIconColumn && __cmplp.isVisualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _11q7glyw _11c82smr _1yt46tij _2rko1l7b _k48p1wq8 _syaz1fxt _16qsidpf _1e0c116y _80omtlke _1di6qbzx _irr3qbzx",
            __cmplp.isIconColumn ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb5bbd562c0ca574$var$SortHeadCellContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconColumn: isIconColumn, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_tsntec": (0, $lD23V.default)(`${"var(--ds-space-050, 4px)"} ${__cmplp.isIconColumn && __cmplp.isVisualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _11q7glyw _11c81vhk _1yt46tij _2rkoglpi _syaz1gjq _4cvr1h6o _1e0c116y _80omtlke _1di6qbzx _irr3qbzx",
            __cmplp.isIconColumn ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
});
const $cb5bbd562c0ca574$var$SortHeadCellContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $cb5bbd562c0ca574$var$SortHeadCellContainerNew, $cb5bbd562c0ca574$var$SortHeadCellContainerOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb5bbd562c0ca574$var$TooltipContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1p1d1dk0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("588G7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c41b8a7a2a0e885f53178dceb7a8d3e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc46e6d650b1ecb$var$_react = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3bc46e6d650b1ecb$var$_arrowDown = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("cC5ib")));

var $3bc46e6d650b1ecb$var$_arrowDown2 = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("ls8Y7")));
function $3bc46e6d650b1ecb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc46e6d650b1ecb$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $3bc46e6d650b1ecb$var$_react.default.createElement($3bc46e6d650b1ecb$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $3bc46e6d650b1ecb$var$_arrowDown2.default
    }, props));
$3bc46e6d650b1ecb$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $3bc46e6d650b1ecb$var$_default = module.exports.default = $3bc46e6d650b1ecb$var$ArrowDownIcon;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("ls8Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f9e32b81d01f795b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $f9e32b81d01f795b$var$_arrowDown.default
    }));
$f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;

});


parcelRegister("2XBKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $04126d925cf2d546$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04126d925cf2d546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipAscSortingDirectionContent: {
        "id": "simple-table.table-head.table-head-cell.tooltip-asc-sorting-direction-content",
        "defaultMessage": "A \u279E Z"
    },
    tooltipDescSortingDirectionContent: {
        "id": "simple-table.table-head.table-head-cell.tooltip-desc-sorting-direction-content",
        "defaultMessage": "Z \u279E A"
    },
    a11YSortButtonDescriptionLabel: {
        "id": "simple-table.table-head.table-head-cell.a-11-y-sort-button-description-label",
        "defaultMessage": "column sort button"
    }
});

});



parcelRegister("aK8yz", function(module, exports) {

$parcel$export(module.exports, "TableRow", () => $a4795e7a0830d9f7$export$b05581f4e764e162);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $3fed9 = parcelRequire("3fed9");
const $a4795e7a0830d9f7$export$b05581f4e764e162 = ({ columnKeys: columnKeys, cells: cells, isLastRow: isLastRow })=>{
    const Cells = (0, $5uXOq.useMemo)(()=>cells.filter((cell)=>columnKeys.includes(cell.key)).map(({ key: key, content: content })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4795e7a0830d9f7$var$TableCell, {
                isLastRow: isLastRow,
                key: `table-row-cell-${key}`
            }, content)), [
        columnKeys,
        cells,
        isLastRow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4795e7a0830d9f7$var$TableRowContainer, null, Cells);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a4795e7a0830d9f7$var$TableRowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189e18uv _1dqoglyw _1h6d18uv _4t3ickbl _kqswh2mm _1bsb1osq _irr3166n",
            __cmplp.className
        ])
    });
});
const $a4795e7a0830d9f7$var$CellContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastRow: isLastRow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5pio18uv _1h6d18uv _1dqoglyw _189e18uv _r06hglyw _vchhusvi _1e0cdav6 _19bvu2gc _u5f3u2gc _kqswh2mm _s7n4nkob _1bsbzwfg _1lhcu2gc _1o59u2gc",
            __cmplp.isLastRow ? "_n7zlglyw" : "_n7zlzgxb",
            __cmplp.className
        ])
    });
});
const $a4795e7a0830d9f7$var$TableCell = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $a4795e7a0830d9f7$var$CellContainerNew, (0, $3fed9.CellContainer));

});
parcelRegister("3fed9", function(module, exports) {

$parcel$export(module.exports, "CellContainer", () => $5df3abcdfbf91a1b$export$287da707e3318210);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $5df3abcdfbf91a1b$export$287da707e3318210 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5pio18uv _1h6d18uv _1dqoglyw _189e18uv _r06hglyw _vchhusvi _1e0cdav6 _19bvu2gc _u5f3u2gc _kqswh2mm _s7n4nkob _1bsbzwfg _1lhcu2gc _1o59u2gc",
            __cmplp.className
        ])
    });
});

});



parcelRegister("gxECQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1839cdb82b552cc6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1839cdb82b552cc6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tableCaptionAllProjects: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects",
        "defaultMessage": "Table showing all projects"
    },
    tableCaptionAllProjectsAndAllCategories: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-and-all-categories",
        "defaultMessage": "Table showing all projects for all categories."
    },
    tableCaptionSpecificProduct: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product",
        "defaultMessage": "Table showing {product} projects."
    },
    tableCaptionSpecificCategory: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-category",
        "defaultMessage": "Table showing all projects for {category} category"
    },
    tableCaptionSpecificProductAllCategories: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-all-categories",
        "defaultMessage": "Table showing {product} projects for all categories"
    },
    tableCaptionSpecificProductSpecificCategories: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-specific-categories",
        "defaultMessage": "Table showing {product} projects for {category} category"
    }
});

});

parcelRegister("1Mh8b", function(module, exports) {

$parcel$export(module.exports, "getTableHeader", () => $bdb65469ab756b5d$export$ee524713fdf0677d);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $gkT9B = parcelRequire("gkT9B");

var $eAfBM = parcelRequire("eAfBM");

var $eErHx = parcelRequire("eErHx");
const $bdb65469ab756b5d$export$ee524713fdf0677d = ({ formatMessage: formatMessage, isAnonymous: isAnonymous, shouldShowCategories: shouldShowCategories, isAdminSettingsContext: isAdminSettingsContext })=>({
        cells: [
            {
                key: (0, $gkT9B.TableColumns).Favourites,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eAfBM.StarredHeader), {
                    label: formatMessage((0, $eErHx.messages).starred)
                }),
                width: 2.85,
                testId: 'jira-project-directory.results-table.header.favourites',
                disabled: isAnonymous,
                isIconColumn: true,
                textAlign: 'center'
            },
            {
                key: (0, $gkT9B.TableColumns).Name,
                content: formatMessage((0, $eErHx.messages).name),
                width: 22,
                testId: 'jira-project-directory.results-table.header.name'
            },
            {
                key: (0, $gkT9B.TableColumns).Key,
                content: formatMessage((0, $eErHx.messages).key),
                width: 12,
                testId: 'jira-project-directory.results-table.header.key'
            },
            {
                key: (0, $gkT9B.TableColumns).Type,
                content: formatMessage((0, $eErHx.messages).type),
                width: 20,
                testId: 'jira-project-directory.results-table.header.type'
            },
            {
                key: (0, $gkT9B.TableColumns).Lead,
                content: formatMessage((0, $eErHx.messages).owner),
                width: shouldShowCategories ? 20 : 36,
                testId: 'jira-project-directory.results-table.header.owner'
            },
            {
                key: (0, $gkT9B.TableColumns).Category,
                content: formatMessage((0, $eErHx.messages).category),
                width: 16,
                testId: 'jira-project-directory.results-table.header.category',
                disabled: !shouldShowCategories
            },
            {
                key: (0, $gkT9B.TableColumns).LastIssueUpdate,
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eErHx.messages).lastIssueUpdateIssueTermRefresh : (0, $eErHx.messages).lastIssueUpdate),
                width: 16,
                testId: 'jira-project-directory.results-table.header.last-issue-update',
                disabled: !isAdminSettingsContext
            },
            {
                key: (0, $gkT9B.TableColumns).Url,
                content: formatMessage((0, $eErHx.messages).projectUrl),
                width: 7,
                testId: 'jira-project-directory.results-table.header.url'
            },
            {
                key: (0, $gkT9B.TableColumns).Action,
                content: formatMessage((0, $eErHx.messages).action),
                width: 8,
                textAlign: 'right',
                testId: 'jira-project-directory.results-table.header.action'
            }
        ].filter((cell)=>!cell.disabled).map((cell)=>({
                ...cell,
                isSortable: (0, $gkT9B.SortableColumns).includes(cell.key)
            }))
    });

});
parcelRegister("eAfBM", function(module, exports) {

$parcel$export(module.exports, "StarredHeader", () => $3b5b4e0536886ce1$export$808dc759b0b23f14);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5IcUR = parcelRequire("5IcUR");
const $3b5b4e0536886ce1$export$808dc759b0b23f14 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b5b4e0536886ce1$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))), {
        color: "currentColor",
        label: label,
        LEGACY_size: "small"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b5b4e0536886ce1$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eErHx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2c4015d2e43a75d8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2c4015d2e43a75d8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.starred",
        "defaultMessage": "Starred"
    },
    name: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.name",
        "defaultMessage": "Name"
    },
    key: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.key",
        "defaultMessage": "Key"
    },
    type: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.type",
        "defaultMessage": "Type"
    },
    owner: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.owner",
        "defaultMessage": "Lead"
    },
    category: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.category",
        "defaultMessage": "Category"
    },
    lastIssueUpdate: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.last-issue-update",
        "defaultMessage": "Last issue update"
    },
    projectUrl: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.project-url",
        "defaultMessage": "Project URL"
    },
    action: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.action",
        "defaultMessage": "More actions"
    },
    lastIssueUpdateIssueTermRefresh: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.last-issue-update-issue-term-refresh",
        "defaultMessage": "Last work update"
    }
});

});


parcelRegister("6KK5t", function(module, exports) {

$parcel$export(module.exports, "getTableRow", () => $378b92d264a55d83$export$8a668e19c44a2b13);

var $5uXOq = parcelRequire("5uXOq");

var $gkT9B = parcelRequire("gkT9B");

var $1xM33 = parcelRequire("1xM33");

var $5Huo8 = parcelRequire("5Huo8");

var $cKtQP = parcelRequire("cKtQP");

var $dpBMT = parcelRequire("dpBMT");

var $9g60v = parcelRequire("9g60v");

var $1Hnw6 = parcelRequire("1Hnw6");

var $kf2VM = parcelRequire("kf2VM");

var $65Pfm = parcelRequire("65Pfm");

var $3TDIg = parcelRequire("3TDIg");
const $378b92d264a55d83$export$8a668e19c44a2b13 = (projectRef, isAdminSettingsContext = false, jiraQueryRef)=>({
        cells: [
            {
                key: (0, $gkT9B.TableColumns).Favourites,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Huo8.FavoriteCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $gkT9B.TableColumns).Name,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Hnw6.NameCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $gkT9B.TableColumns).Key,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKtQP.KeyCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $gkT9B.TableColumns).Type,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65Pfm.ProjectTypeCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $gkT9B.TableColumns).Lead,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9g60v.LeadCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $gkT9B.TableColumns).Category,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kf2VM.ProjectCategoryCell), {
                    project: projectRef
                })
            },
            ...isAdminSettingsContext ? [
                {
                    key: (0, $gkT9B.TableColumns).LastIssueUpdate,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpBMT.LastIssueUpdateCell), {
                        project: projectRef
                    })
                }
            ] : [],
            {
                key: (0, $gkT9B.TableColumns).Url,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TDIg.UrlCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $gkT9B.TableColumns).Action,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xM33.ActionsCell), {
                    project: projectRef,
                    jiraQueryRef: jiraQueryRef
                })
            }
        ]
    });

});
parcelRegister("1xM33", function(module, exports) {

$parcel$export(module.exports, "ActionsCell", () => $953b1735b9f944fe$export$eee95bbb96e96f7b);

var $ldTWx = parcelRequire("ldTWx");

var $6lRt3 = parcelRequire("6lRt3");

var $k8cj1 = parcelRequire("k8cj1");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $i8Qvm = parcelRequire("i8Qvm");

var $2vSU6 = parcelRequire("2vSU6");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iviep = parcelRequire("iviep");

var $4pdD4 = parcelRequire("4pdD4");

var $ibPPY = parcelRequire("ibPPY");

var $kRt9N = parcelRequire("kRt9N");

var $iVNLr = parcelRequire("iVNLr");

var $lu5k0 = parcelRequire("lu5k0");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $hjSul = parcelRequire("hjSul");

var $dPvGX = parcelRequire("dPvGX");

var $6wfdY = parcelRequire("6wfdY");

var $biPXN = parcelRequire("biPXN");

var $3rWFI = parcelRequire("3rWFI");

var $x3l4g = parcelRequire("x3l4g");
const $953b1735b9f944fe$var$PREMIUM = 'PREMIUM';
function $953b1735b9f944fe$var$useModalReturnFocusTo({ projectToRestore: projectToRestore }) {
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const renderButtonRef = (0, $5uXOq.useRef)(null);
    const setModalReturnFocusTo = (0, $5uXOq.useCallback)(()=>{
        setReturnFocusTo(renderButtonRef);
    }, [
        setReturnFocusTo,
        renderButtonRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectToRestore) setModalReturnFocusTo();
    }, [
        projectToRestore,
        setModalReturnFocusTo,
        setReturnFocusTo
    ]);
    return {
        setModalReturnFocusTo: setModalReturnFocusTo,
        renderButtonRef: renderButtonRef
    };
}
const $953b1735b9f944fe$var$ActionsCellDropdown = ({ project: project, jiraQueryRef: jiraQueryRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'resultsTable'
    });
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const [, { forceUpdate: forceUpdate }] = (0, $dPvGX.useFilter)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const [projectToRestore, setProjectToRestore] = (0, $5uXOq.useState)(null);
    const [activeEntryPoint, setActiveEntryPoint] = (0, $5uXOq.useState)(null);
    const { jiraProjectType: jiraProjectType, jiraProjectName: jiraProjectName, projectStyle: projectStyle, key: key, id: id } = (0, $8Uumt.useFragment)((0, $k8cj1.default), project);
    const jwmNavigationData = (0, $8Uumt.useFragment)((0, $6lRt3.default), jiraQueryRef);
    const { setModalReturnFocusTo: setModalReturnFocusTo, renderButtonRef: renderButtonRef } = $953b1735b9f944fe$var$useModalReturnFocusTo({
        projectToRestore: projectToRestore
    });
    const isCorePremiumUserSeat = Boolean(jwmNavigationData?.jwmLicensing?.currentUserSeatEdition === $953b1735b9f944fe$var$PREMIUM);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            projectId: id
        }), [
        id
    ]);
    const { entryPointReferenceSubject: deleteRefSubject, entryPointActions: deleteActions } = (0, $4mO32.useEntryPoint)((0, $iVNLr.deleteProjectModalEntryPoint), entryPointParams, undefined, // TODO: add performance metrics
    {
        timeToIntent: 50
    });
    const deleteEntryPointRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose: ()=>{},
            onDeleteProjectSuccess: ()=>{
                forceUpdate();
                deleteActions.unload();
            },
            onProjectRestore: setProjectToRestore
        }), [
        deleteActions,
        forceUpdate
    ]);
    const deleteTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(deleteActions);
    const { entryPointReferenceSubject: archiveRefSubject, entryPointActions: archiveActions } = (0, $4mO32.useEntryPoint)((0, $kRt9N.archiveProjectModalEntryPoint), entryPointParams, undefined, // TODO: add performance metrics
    {
        timeToIntent: 50
    });
    const archiveEntryPointRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose: ()=>{},
            onArchiveProjectSuccess: ()=>{
                forceUpdate();
                archiveActions.unload();
            },
            onProjectRestore: setProjectToRestore
        }), [
        archiveActions,
        forceUpdate
    ]);
    const archiveTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(archiveActions);
    const { entryPointReferenceSubject: archiveProjectFeatureGateRefSubject, entryPointActions: archiveProjectFeatureGateActions } = (0, $4mO32.useEntryPoint)((0, $ibPPY.archiveProjectFeatureGateModalEntryPoint), {});
    const archiveFeatureGateEntryPointRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: ()=>{
                archiveProjectFeatureGateActions.unload();
            }
        }), [
        archiveProjectFeatureGateActions
    ]);
    const archiveFeatureGateTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(archiveProjectFeatureGateActions);
    const handleTrashClick = (0, $5uXOq.useCallback)(()=>{
        setModalReturnFocusTo();
        setActiveEntryPoint({
            entryPointReferenceSubject: deleteRefSubject,
            runtimeProps: deleteEntryPointRuntimeProps,
            entryPointActions: deleteActions,
            id: 'project-delete-modal'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'trashDropdownItem');
    }, [
        setModalReturnFocusTo,
        deleteRefSubject,
        deleteEntryPointRuntimeProps,
        deleteActions,
        analyticsEvent
    ]);
    const isSoftwareAppStandardEdition = (0, $iviep.isStandardEdition)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
    const isSoftwareAppFreeEdition = (0, $iviep.isFreeEdition)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
    const handleArchiveClick = (0, $5uXOq.useCallback)(()=>{
        setModalReturnFocusTo();
        if ((isSoftwareAppStandardEdition || isSoftwareAppFreeEdition) && (jiraProjectType === (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) || jiraProjectType === (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT))) {
            setActiveEntryPoint({
                entryPointReferenceSubject: archiveProjectFeatureGateRefSubject,
                runtimeProps: archiveFeatureGateEntryPointRuntimeProps,
                entryPointActions: archiveProjectFeatureGateActions,
                id: 'project-archive-feature-gate-modal'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectArchivingFeatureGateItem');
        } else {
            setActiveEntryPoint({
                entryPointReferenceSubject: archiveRefSubject,
                runtimeProps: archiveEntryPointRuntimeProps,
                entryPointActions: archiveActions,
                id: 'project-archive-modal'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'archiveDropdownItem');
        }
    }, [
        setModalReturnFocusTo,
        isSoftwareAppStandardEdition,
        isSoftwareAppFreeEdition,
        jiraProjectType,
        archiveProjectFeatureGateRefSubject,
        archiveFeatureGateEntryPointRuntimeProps,
        archiveProjectFeatureGateActions,
        analyticsEvent,
        archiveRefSubject,
        archiveEntryPointRuntimeProps,
        archiveActions
    ]);
    const handleSettingsClick = (0, $5uXOq.useCallback)(()=>{
        setIsDropdownOpen(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'settingsDropdownItem');
    }, [
        analyticsEvent
    ]);
    const handleDropdownClick = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dropdownMenu');
    }, [
        analyticsEvent
    ]);
    const isSimplified = projectStyle === 'TEAM_MANAGED_PROJECT'; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectType = jiraProjectType?.toLowerCase();
    const archiveTriggerRefToUse = (jiraProjectType === (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) || jiraProjectType === (0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT)) && (isSoftwareAppStandardEdition || isSoftwareAppFreeEdition) ? archiveFeatureGateTriggerRef : archiveTriggerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($953b1735b9f944fe$var$ActionCellWrapper, null, activeEntryPoint !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        ...activeEntryPoint,
        id: id,
        packageName: `jira-projects-directory-v3-delete-${id}`
    }), projectToRestore !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4pdD4.default), {
        ...projectToRestore,
        onProjectRestoreSuccess: ()=>{
            setProjectToRestore(null);
            forceUpdate();
        },
        onClose: ()=>setProjectToRestore(null),
        onProjectRestoreFailure: ()=>setProjectToRestore(null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: handleDropdownClick,
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                appearance: "subtle",
                "aria-label": formatMessage((0, $3rWFI.default).moreActions, {
                    name: jiraProjectName
                }),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    spacing: "spacious",
                    label: ""
                }),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, renderButtonRef)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ), {
        onClick: handleSettingsClick,
        component: ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                ...props,
                onClick: onClick,
                to: (0, $x3l4g.getSettingsUrl)(projectType, isSimplified, key)
            })
    }, formatMessage((0, $3rWFI.default).settings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $biPXN.TrashProjectDropdownItem), {
        projectType: projectType,
        isAdmin: isAdmin,
        canAdministerProject: true,
        isSimplified: isSimplified,
        ref: deleteTriggerRef,
        onClick: handleTrashClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6wfdY.ArchiveProjectDropdownItem), {
        projectType: projectType,
        isAdmin: isAdmin,
        canAdministerProject: true,
        isSimplified: isSimplified,
        ref: archiveTriggerRefToUse,
        onClick: handleArchiveClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat
    }))));
};
const $953b1735b9f944fe$export$eee95bbb96e96f7b = ({ project: project, jiraQueryRef: jiraQueryRef })=>{
    const dataRef = (0, $8Uumt.useFragment)((0, $ldTWx.default), project);
    if (!dataRef?.canViewProjectConfig?.canPerform) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($953b1735b9f944fe$var$ActionsCellDropdown, {
        project: dataRef,
        jiraQueryRef: jiraQueryRef
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $953b1735b9f944fe$var$ActionCellWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ldTWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $555da9684e607856$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f107b1dd5aac0ef2fc16a6661a002b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $555da9684e607856$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "actionsCell_projectsDirectoryV3_project",
    "selections": [
        {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_project"
        }
    ],
    "type": "JiraProject"
};
$555da9684e607856$var$node.hash = "c8748624e96975706ef2288b147d4354";
var $555da9684e607856$export$2e2bcd8739ae039 = $555da9684e607856$var$node;

});

parcelRegister("6lRt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $472128e18ca20072$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ed08c6672a1eaf3b9b82bab3a381f5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $472128e18ca20072$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$472128e18ca20072$var$node.hash = "5b00115542e25c7594cc5725fc674963";
var $472128e18ca20072$export$2e2bcd8739ae039 = $472128e18ca20072$var$node;

});

parcelRegister("k8cj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $259ea62f8fda0b43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<364088419a35537f43370e010e4d245d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $259ea62f8fda0b43$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_project",
    "selections": [
        {
            "alias": "jiraProjectType",
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "jiraProjectName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraProject"
};
$259ea62f8fda0b43$var$node.hash = "c940602017bcd3fd11260c66a06307d5";
var $259ea62f8fda0b43$export$2e2bcd8739ae039 = $259ea62f8fda0b43$var$node;

});

parcelRegister("iviep", function(module, exports) {

$parcel$export(module.exports, "hasPermissionGate", () => $39a9a56ffba74d2e$export$2d7869ada39bf0b);
$parcel$export(module.exports, "isStandardEdition", () => $39a9a56ffba74d2e$export$4b1af5399a63f452);
$parcel$export(module.exports, "isFreeEdition", () => $39a9a56ffba74d2e$export$a8e9f6df1deeb7d);
$parcel$export(module.exports, "hasPermissionToArchive", () => $39a9a56ffba74d2e$export$70eef98d89c5d158);

var $2vSU6 = parcelRequire("2vSU6");

var $ldyPw = parcelRequire("ldyPw");
const $39a9a56ffba74d2e$export$2d7869ada39bf0b = (projectType, appEditions)=>(0, $ldyPw.getEditionForProject)(projectType, appEditions) === (0, $ldyPw.PREMIUM_EDITION);
const $39a9a56ffba74d2e$export$4b1af5399a63f452 = (projectType, appEditions)=>(0, $ldyPw.getEditionForProject)(projectType, appEditions) === (0, $ldyPw.STANDARD_EDITION);
const $39a9a56ffba74d2e$export$a8e9f6df1deeb7d = (projectType, appEditions)=>(0, $ldyPw.getEditionForProject)(projectType, appEditions) === (0, $ldyPw.FREE_EDITION);
const $39a9a56ffba74d2e$var$hasPermissionToArchiveProject = (isSimplified, isAdmin, canAdministerProject)=>{
    if (isSimplified) return isAdmin || canAdministerProject; // Either Jira admins or Project admins can archive the simplified/next-gen project
    return isAdmin; // Only Jira admins can archive the classic software project
};
const $39a9a56ffba74d2e$export$70eef98d89c5d158 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
    switch(projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return $39a9a56ffba74d2e$var$hasPermissionToArchiveProject(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
};

});

parcelRegister("4pdD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ad70d2ac8fd8e5c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3ad70d2ac8fd8e5c$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("3RVLX")), {
    moduleId: "./src/packages/project-pages/project-restore/project-restore-modal/src/index.tsx"
});
const $3ad70d2ac8fd8e5c$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-restore-modal",
        packageName: "jira-project-restore-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-restore-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: (0, $14d5c91aea6dd559$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ad70d2ac8fd8e5c$var$LazyComponent, props)));
var $3ad70d2ac8fd8e5c$export$2e2bcd8739ae039 = $3ad70d2ac8fd8e5c$var$Component;

});
const $14d5c91aea6dd559$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $14d5c91aea6dd559$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';

parcelRegister("3RVLX", function(module, exports) {

let $2d1322c025826f24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d1322c025826f24$var$load("l8d9V").then(()=>parcelRequire('8itfQ'));

});


parcelRegister("ibPPY", function(module, exports) {

$parcel$export(module.exports, "archiveProjectFeatureGateModalEntryPoint", () => $efb56fa3ccd065b0$export$fcdeeeabe3fc5ecf);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $efb56fa3ccd065b0$export$fcdeeeabe3fc5ecf = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("FTFDl")), {
        moduleId: "1b29af53"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("FTFDl", function(module, exports) {

let $07df0374232915e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $07df0374232915e7$var$load("h2MrD"),
    $07df0374232915e7$var$load("bYT2S"),
    $07df0374232915e7$var$load("6DFtN")
]).then(()=>parcelRequire('awct0'));

});


parcelRegister("kRt9N", function(module, exports) {

$parcel$export(module.exports, "archiveProjectModalEntryPoint", () => $de9347d67c4d5780$export$31eb70b07b11d874);

var $6mG7r = parcelRequire("6mG7r");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $de9347d67c4d5780$export$31eb70b07b11d874 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("urTOu")), {
        moduleId: "a707d335"
    }),
    getPreloadProps: ({ projectId: projectId })=>({
            queries: {
                project: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $6mG7r.default,
                    variables: {
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("6mG7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b91c010617dcca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e47b16dcd2a4c0090f75b99be9dfb50>>
 * @relayHash f80461cb9c20e5817d234cd6193aff07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9daa742fffdffb3be75a50f4d433a30c07a6212c4a9d23a43b3664323d1faa0
const $42b91c010617dcca$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a9daa742fffdffb3be75a50f4d433a30c07a6212c4a9d23a43b3664323d1faa0",
        "metadata": {},
        "name": "uiArchiveProjectModal_getProjectQuery",
        "operationKind": "query",
        "text": null
    }
};
var $42b91c010617dcca$export$2e2bcd8739ae039 = $42b91c010617dcca$var$node;

});

parcelRegister("urTOu", function(module, exports) {

let $05b871a8ce73ade0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05b871a8ce73ade0$var$load("8WZsV").then(()=>parcelRequire('enCHC'));

});


parcelRegister("iVNLr", function(module, exports) {

$parcel$export(module.exports, "deleteProjectModalEntryPoint", () => $be5cb60b714e4982$export$71ab1db8fa3662de);

var $7L4m7 = parcelRequire("7L4m7");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $be5cb60b714e4982$export$71ab1db8fa3662de = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9UdLY")), {
        moduleId: "0a83cef5"
    }),
    getPreloadProps: ({ projectId: projectId })=>({
            queries: {
                project: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $7L4m7.default,
                    variables: {
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("7L4m7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad982b59eb99c13b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a1fd0fb256e69d343384e4492a60188>>
 * @relayHash bedfc53abda2b09909778822a77ae8e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b970039aa2992a80e17db04733801c9fc94a870f85ad01abf94a227b9b0a28de
const $ad982b59eb99c13b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b970039aa2992a80e17db04733801c9fc94a870f85ad01abf94a227b9b0a28de",
        "metadata": {},
        "name": "uiDeleteProjectModal_getProjectQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ad982b59eb99c13b$export$2e2bcd8739ae039 = $ad982b59eb99c13b$var$node;

});

parcelRegister("9UdLY", function(module, exports) {

let $736406fd60947449$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $736406fd60947449$var$load("hPzOn"),
    $736406fd60947449$var$load("cM9em"),
    $736406fd60947449$var$load("fr9NE"),
    $736406fd60947449$var$load("2qoav")
]).then(()=>parcelRequire('9cip1'));

});


parcelRegister("6wfdY", function(module, exports) {

$parcel$export(module.exports, "ArchiveProjectDropdownItem", () => $af9be29b8402bcf0$export$26fac2325408ae57);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $j5csE = parcelRequire("j5csE");
const $af9be29b8402bcf0$export$26fac2325408ae57 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5csE.ProjectArchiveTrigger), {
        ...props,
        Component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                ref: ref,
                onClick: props.onClick
            }, children)
    }));

});
parcelRegister("j5csE", function(module, exports) {

$parcel$export(module.exports, "useShouldShowArchiveProjectTrigger", () => $0115ce7a250913b5$export$b73fe2adeac2987c);
$parcel$export(module.exports, "ProjectArchiveTrigger", () => $0115ce7a250913b5$export$8901cb385df588dc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6B7KL = parcelRequire("6B7KL");

var $3u0c5 = parcelRequire("3u0c5");

var $41CZr = parcelRequire("41CZr");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $k9JTq = parcelRequire("k9JTq");

var $3hsHx = parcelRequire("3hsHx");

var $iviep = parcelRequire("iviep");
function $0115ce7a250913b5$export$b73fe2adeac2987c({ isAdmin: isAdmin, isSimplified: isSimplified, canAdministerProject: canAdministerProject, projectType: projectType, shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger, isCorePremiumUserSeat: isCorePremiumUserSeat }) {
    const appEditions = (0, $k9JTq.useAppEditions)();
    if (!(0, $iviep.hasPermissionToArchive)({
        projectType: projectType,
        isSimplified: isSimplified,
        isAdmin: isAdmin,
        canAdministerProject: canAdministerProject
    })) return false;
    const isJswPremiumEdition = (0, $iviep.hasPermissionGate)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
    const isJswStandardEdition = (0, $iviep.isStandardEdition)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
    const isJswFreeEdition = (0, $iviep.isFreeEdition)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
    const isJsmPremiumEdition = (0, $iviep.hasPermissionGate)((0, $2vSU6.SERVICE_DESK_PROJECT), appEditions);
    if (projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isJswPremiumEdition || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && isJsmPremiumEdition) return {
        showPremiumLozenge: false
    };
     // Standard or Free Edition admins should see the Project archiving FG for JSW and Core Projects
    if (isAdmin && !shouldHideFeatureGateTrigger && (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (isJswStandardEdition || isJswFreeEdition)) return {
        showPremiumLozenge: true
    };
     // Enable Project Archiving feature for Core Projects if either Software, Service Desk or Core are Premium
    if (projectType === (0, $2vSU6.CORE_PROJECT) && isCorePremiumUserSeat) return {
        showPremiumLozenge: false
    };
    return false;
}
const $0115ce7a250913b5$export$8901cb385df588dc = (props)=>{
    const { projectType: projectType, onClick: onClick, isAdmin: isAdmin, canAdministerProject: canAdministerProject, isSimplified: isSimplified, Component: Component, isCorePremiumUserSeat: isCorePremiumUserSeat, shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger, customLabelText: customLabelText } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const premiumLozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0115ce7a250913b5$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: "new"
        }, formatMessage((0, $3hsHx.default).premiumLozenge))), [
        formatMessage
    ]);
    const getDropdownItem = ({ showPremiumLozenge: showPremiumLozenge })=>{
        const dropdownChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, customLabelText || formatMessage(projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? (0, $3hsHx.default).archiveTriggerServiceManagement : (0, $3hsHx.default).archiveTrigger), showPremiumLozenge && premiumLozenge);
        return Component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null, dropdownChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            elemBefore: (0, $4R6GH.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41CZr))), {
                testId: "project-archive-trigger.ui.archive-icon",
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: onClick
        }, dropdownChildren);
    };
    const shouldShowResult = $0115ce7a250913b5$export$b73fe2adeac2987c({
        isAdmin: isAdmin,
        isSimplified: isSimplified,
        canAdministerProject: canAdministerProject,
        projectType: projectType,
        shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger,
        isCorePremiumUserSeat: isCorePremiumUserSeat
    });
    if (!shouldShowResult) return null;
    return getDropdownItem(shouldShowResult);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0115ce7a250913b5$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9 _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3hsHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe2f488870be757$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfe2f488870be757$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    archiveTrigger: {
        "id": "project-archive-trigger.archive-trigger",
        "defaultMessage": "Archive"
    },
    archiveTriggerServiceManagement: {
        "id": "project-archive-trigger.archive-trigger-service-management",
        "defaultMessage": "Move to archive"
    },
    premiumLozenge: {
        "id": "project-archive-trigger.premium-lozenge",
        "defaultMessage": "Premium"
    }
});

});



parcelRegister("biPXN", function(module, exports) {

$parcel$export(module.exports, "TrashProjectDropdownItem", () => $19f4d9de7fb80565$export$eb302d626a2eaf73);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $kDO0r = parcelRequire("kDO0r");

var $8JRs9 = parcelRequire("8JRs9");
const $19f4d9de7fb80565$export$eb302d626a2eaf73 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, ...args }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!(0, $kDO0r.shouldShowTrashProjectTrigger)(args)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        ref: ref,
        onClick: onClick
    }, formatMessage((0, $8JRs9.default).delete));
});

});
parcelRegister("kDO0r", function(module, exports) {

$parcel$export(module.exports, "shouldShowTrashProjectTrigger", () => $ea1964a427a6c77f$export$efbe59f7e76b22d6);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");
const $ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType = (isSimplified, isAdmin, canAdministerProject)=>{
    if (isSimplified) return isAdmin || canAdministerProject; // Either Jira admins or Project admins can trash the simplified/next-gen project
    return isAdmin; // Only Jira admins can trash the classic software project
};
// There is no simplified/next-gen version of core project type. Only Jira admins can trash the core project
const $ea1964a427a6c77f$var$shouldShowTrashTriggerForCoreType = (isAdmin)=>isAdmin;
// Same behaviour as in Software:
// Either Jira admins or Project admins can trash the simplified/next-gen JSM project
// Only Jira admins can trash the classic JSM project
const $ea1964a427a6c77f$var$shouldShowTrashTriggerForJSMType = (isSimplified, isAdmin, canAdministerProject)=>$ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
const $ea1964a427a6c77f$export$efbe59f7e76b22d6 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
    if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return $ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return $ea1964a427a6c77f$var$shouldShowTrashTriggerForCoreType(isAdmin);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $ea1964a427a6c77f$var$shouldShowTrashTriggerForJSMType(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
    switch(projectType){
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return $ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
        case 0, $2vSU6.CORE_PROJECT:
            return $ea1964a427a6c77f$var$shouldShowTrashTriggerForCoreType(isAdmin);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $ea1964a427a6c77f$var$shouldShowTrashTriggerForJSMType(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
};

});

parcelRegister("8JRs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2d8f05f17607c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9d2d8f05f17607c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.delete-project-menu-item.delete",
        "defaultMessage": "Move to trash"
    }
});

});


parcelRegister("3rWFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f888a411db236a8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8f888a411db236a8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more-actions",
        "defaultMessage": "More actions for {name}"
    },
    more: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("x3l4g", function(module, exports) {

$parcel$export(module.exports, "getSettingsUrl", () => $8a87a6fc4b868af5$export$3fe840d461122951);

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");
const $8a87a6fc4b868af5$var$getClassicSettingsUrl = (projectType, projectKey)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? `/jira/servicedesk/projects/${projectKey}/settings` : `/projects/${projectKey}/settings`;
const $8a87a6fc4b868af5$export$3fe840d461122951 = (projectType, isSimplified, projectKey)=>!isSimplified || !projectType ? $8a87a6fc4b868af5$var$getClassicSettingsUrl(projectType, projectKey) : (0, $02Psx.getNextgenSettingsUrl)(projectType, projectKey);

});


parcelRegister("5Huo8", function(module, exports) {

$parcel$export(module.exports, "FavoriteCell", () => $e3bdc0b0936b2c61$export$d67ed47628a04c08);

var $3gMXQ = parcelRequire("3gMXQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gd976 = parcelRequire("gd976");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $e3bdc0b0936b2c61$export$d67ed47628a04c08 = ({ project: project })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'resultsTable'
    });
    const data = (0, $8Uumt.useFragment)((0, $3gMXQ.default), project);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'FavoriteButton');
    }, [
        analyticsEvent
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return !data.canViewIssue?.canPerform ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd976.FavoriteCell), {
        queryRef: data,
        onClick: handleClick
    });
    // Delete the following during getWillShowNav4 cleanup
    const { id: id, name: name, favouriteValue: favouriteValue, canViewIssue: canViewIssue } = data;
    if (!canViewIssue?.canPerform || !favouriteValue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd976.FavoriteCellOld), {
        id: id,
        favoriteItemName: name,
        favouriteValueRef: favouriteValue,
        onClick: handleClick
    });
};

});
parcelRegister("3gMXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7c68c8adef0634$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d44d33f756a3a4cff1533c4ee4f94ea7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9b7c68c8adef0634$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "favouriteCell_projectsDirectoryV3_FavoriteCell",
    "selections": [
        {
            "alias": "canViewIssue",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_ISSUES"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"VIEW_ISSUES\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "favouriteCell_directoryBaseV3_FavoriteCell_queryRef"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "favouriteCell_directoryBaseV3_FavoriteCellOld_favouriteValueRef"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraProject"
};
$9b7c68c8adef0634$var$node.hash = "ad54d41b3040372f85a46039e18e78ea";
var $9b7c68c8adef0634$export$2e2bcd8739ae039 = $9b7c68c8adef0634$var$node;

});

parcelRegister("gd976", function(module, exports) {

$parcel$export(module.exports, "FavoriteCell", () => $0fca16bce44cd801$export$d67ed47628a04c08);
$parcel$export(module.exports, "FavoriteCellOld", () => $0fca16bce44cd801$export$fdcdbda2ebc451a1);

var $1bDfu = parcelRequire("1bDfu");

var $ajR4C = parcelRequire("ajR4C");

var $i62GJ = parcelRequire("i62GJ");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $1Jl81 = parcelRequire("1Jl81");

var $4R6GH = parcelRequire("4R6GH");

var $hcObS = parcelRequire("hcObS");

var $4041n = parcelRequire("4041n");

var $pa9q9 = parcelRequire("pa9q9");

var $dXq4S = parcelRequire("dXq4S");

var $l3Aku = parcelRequire("l3Aku");
const $0fca16bce44cd801$export$d67ed47628a04c08 = ({ queryRef: queryRef, onClick: onClick })=>{
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $4041n.useChangeFavorite)();
    const { id: id, name: name, isFavourite: isFavourite } = (0, $8Uumt.useFragment)((0, $i62GJ.default), queryRef);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onClick?.({
            isFavourite: !isFavourite
        });
        changeFavoriteMutation({
            id: id,
            value: !isFavourite,
            typename: 'JiraProject'
        });
    }, [
        onClick,
        isFavourite,
        changeFavoriteMutation,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fca16bce44cd801$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        onClick: handleClick,
        isShownInList: true,
        isFavorite: isFavourite,
        favoriteItemName: name
    }));
};
const $0fca16bce44cd801$export$fdcdbda2ebc451a1 = ({ id: entityId, favoriteItemName: favoriteItemName, favouriteValueRef: favouriteValueRef, onClick: onClick })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { updateFavoriteState: updateFavoriteState } = (0, $4041n.useChangeFavorite)();
    const { __id: recordId, isFavourite: isFavourite } = (0, $8Uumt.useFragment)((0, $ajR4C.default), favouriteValueRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $1bDfu.default));
    const updateFavouriteRecord = (0, $5uXOq.useCallback)((store)=>{
        const { resourceId: resourceId, resourceType: resourceType } = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $1Jl81.AnyAri).parse(entityId) : (0, $dXq4S.getAriConfig)(entityId);
        const favouriteEntityRecord = store.get(recordId);
        if (resourceType === 'project') updateFavoriteState({
            id: resourceId,
            type: 'projects',
            value: !isFavourite
        });
        favouriteEntityRecord?.setValue(!isFavourite, 'isFavourite');
    }, [
        isFavourite,
        recordId,
        entityId,
        updateFavoriteState
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onClick && onClick({
            isFavourite: !isFavourite
        });
        commit({
            variables: {
                entityId: entityId,
                isFavourite: !isFavourite
            },
            optimisticUpdater: updateFavouriteRecord,
            updater: updateFavouriteRecord,
            onCompleted: (data)=>{
                if (!data?.jira?.setEntityIsFavourite?.success) showFlag({
                    type: 'error',
                    title: (0, $l3Aku.default).title,
                    description: (0, $l3Aku.default).description,
                    messageId: 'directory-base-v3.ui.table-cells.favourite-cell.show-flag.error',
                    messageType: 'transactional'
                });
            }
        });
    }, [
        onClick,
        isFavourite,
        commit,
        entityId,
        updateFavouriteRecord,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fca16bce44cd801$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        onClick: handleClick,
        isShownInList: true,
        isFavorite: isFavourite,
        favoriteItemName: favoriteItemName
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fca16bce44cd801$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1bDfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $89b380f8d70db9a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0b2fed1c40da58e8adc6b850f137f9e>>
 * @relayHash d4a9710e84ebea84a643c6ab959e756e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 677bbcd9c25049b9a4296d20d4a52bcaa99e82e0d0f12414fac1ed3dbbfa1e31
const $89b380f8d70db9a5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFavourite"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "entityId",
                                    "variableName": "entityId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isFavourite",
                                    "variableName": "isFavourite"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "favouriteCell_directoryBaseV3_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "favouriteCell_directoryBaseV3_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "677bbcd9c25049b9a4296d20d4a52bcaa99e82e0d0f12414fac1ed3dbbfa1e31",
            "metadata": {},
            "name": "favouriteCell_directoryBaseV3_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$89b380f8d70db9a5$var$node.hash = "bd17a743d8447fa8141ce0ba8c8f1012";
var $89b380f8d70db9a5$export$2e2bcd8739ae039 = $89b380f8d70db9a5$var$node;

});

parcelRegister("ajR4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $323ac085f29fc95e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eeddd7d3055f31cacc40c6df5ef698f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $323ac085f29fc95e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "favouriteCell_directoryBaseV3_FavoriteCellOld_favouriteValueRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraFavouriteValue"
};
$323ac085f29fc95e$var$node.hash = "b3217e19a577d125349014040cc34d96";
var $323ac085f29fc95e$export$2e2bcd8739ae039 = $323ac085f29fc95e$var$node;

});

parcelRegister("i62GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc684d17909d4244$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f30ced9f25eaab8d1e39e57e0b3dc8be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dc684d17909d4244$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "favouriteCell_directoryBaseV3_FavoriteCell_queryRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        }
    ],
    "type": "JiraProject"
};
$dc684d17909d4244$var$node.hash = "600c66fd2f77bc9eec46edf5294a9a60";
var $dc684d17909d4244$export$2e2bcd8739ae039 = $dc684d17909d4244$var$node;

});

parcelRegister("l3Aku", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e49bd54aff07a59$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9e49bd54aff07a59$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directory-base-v3.table-cells.favourite-cell.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "directory-base-v3.table-cells.favourite-cell.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("cKtQP", function(module, exports) {

$parcel$export(module.exports, "KeyCell", () => $a6c5ff1d3d963ca3$export$4d17c2f4d9bbf823);

var $62jWf = parcelRequire("62jWf");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $a6c5ff1d3d963ca3$export$4d17c2f4d9bbf823 = ({ project: project })=>{
    const { key: key } = (0, $8Uumt.useFragment)((0, $62jWf.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, key);
};

});
parcelRegister("62jWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9bca1dbeaf30902$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66b9c8f5cdf7d37c300b3e6d4ae9594d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9bca1dbeaf30902$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "keyCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$b9bca1dbeaf30902$var$node.hash = "8366f681ad04b41cb180bc7a28c738a4";
var $b9bca1dbeaf30902$export$2e2bcd8739ae039 = $b9bca1dbeaf30902$var$node;

});


parcelRegister("dpBMT", function(module, exports) {

$parcel$export(module.exports, "LastIssueUpdateCell", () => $86c4b041a3cfb14e$export$c2180874b4ed0214);

var $gcQJe = parcelRequire("gcQJe");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $k71ZQ = parcelRequire("k71ZQ");
const $86c4b041a3cfb14e$export$c2180874b4ed0214 = ({ project: project })=>{
    const { lastUpdatedToolTipDate: lastUpdatedToolTipDate, lastUpdatedDisplayDate: lastUpdatedDisplayDate } = (0, $8Uumt.useFragment)((0, $gcQJe.default), project);
    if (!lastUpdatedDisplayDate) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k71ZQ.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: lastUpdatedToolTipDate,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, lastUpdatedDisplayDate)));
};

});
parcelRegister("gcQJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dcc8f1aebe109db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17cbac72bd869ab640a0ccd5a3afce47>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3dcc8f1aebe109db$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lastIssueUpdateCell_projectsDirectoryV3",
    "selections": [
        {
            "alias": "lastUpdatedToolTipDate",
            "args": [
                {
                    "kind": "Literal",
                    "name": "format",
                    "value": "COMPLETE_DATETIME_FORMAT"
                }
            ],
            "kind": "ScalarField",
            "name": "lastUpdatedFormatted",
            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
        },
        {
            "alias": "lastUpdatedDisplayDate",
            "args": [
                {
                    "kind": "Literal",
                    "name": "format",
                    "value": "RELATIVE"
                }
            ],
            "kind": "ScalarField",
            "name": "lastUpdatedFormatted",
            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
        }
    ],
    "type": "JiraProject"
};
$3dcc8f1aebe109db$var$node.hash = "be249fa705b1ccb8ba2a516f14f08647";
var $3dcc8f1aebe109db$export$2e2bcd8739ae039 = $3dcc8f1aebe109db$var$node;

});

parcelRegister("k71ZQ", function(module, exports) {

$parcel$export(module.exports, "CellWrapper", () => $5e2591e176309da1$export$4812fadef83edffe);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $5e2591e176309da1$export$4812fadef83edffe = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9g60v", function(module, exports) {

$parcel$export(module.exports, "LeadCell", () => $8e208bc361a14491$export$53c185d8cac45d1d);

var $cYWJt = parcelRequire("cYWJt");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3BX7N = parcelRequire("3BX7N");
const $8e208bc361a14491$export$53c185d8cac45d1d = ({ project: project })=>{
    const data = (0, $8Uumt.useFragment)((0, $cYWJt.default), project);
    return data?.lead ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BX7N.UserProfile), {
        dataRef: data.lead
    }) : null;
};

});
parcelRegister("cYWJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $580b0ea2b842b806$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2559e9ee4fe799ba020998c3c1d63439>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $580b0ea2b842b806$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "leadCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "lead",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "userProfile_directoryBaseV3"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$580b0ea2b842b806$var$node.hash = "900649656e1e2128dc46e511bce9897f";
var $580b0ea2b842b806$export$2e2bcd8739ae039 = $580b0ea2b842b806$var$node;

});

parcelRegister("3BX7N", function(module, exports) {

$parcel$export(module.exports, "UserProfile", () => $16c5a599774d5a20$export$b7b58f2e100445f7);

var $eV9WL = parcelRequire("eV9WL");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2QW4M = parcelRequire("2QW4M");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");
const $16c5a599774d5a20$var$UserProfile = ({ dataRef: dataRef })=>{
    const { accountId: accountId, name: displayName, picture: avatarUrl } = (0, $8Uumt.useFragment)((0, $eV9WL.default), dataRef);
    const props = {
        accountId: accountId,
        prepopulatedData: {
            fullName: displayName
        }
    };
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QW4M.AsyncProfileCardNext), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $16c5a599774d5a20$var$containerStyles,
        "data-testId": `directory-user-profile-${accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $16c5a599774d5a20$var$avatarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: "circle"
    })), (0, $4R6GH.fg)('visual-refresh-projects-truncate-user-name') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        maxLines: 1
    }, displayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $16c5a599774d5a20$var$textStyles
    }, displayName))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QW4M.AsyncProfileCardNext), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16c5a599774d5a20$var$ContentContainer, {
        "data-testId": `directory-user-profile-${accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16c5a599774d5a20$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: "circle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16c5a599774d5a20$var$TextContainer, null, displayName)));
};
const $16c5a599774d5a20$export$b7b58f2e100445f7 = /*#__PURE__*/ (0, $5uXOq.memo)($16c5a599774d5a20$var$UserProfile);
const $16c5a599774d5a20$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16c5a599774d5a20$var$AvatarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
            __cmplp.className
        ])
    });
});
const $16c5a599774d5a20$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $16c5a599774d5a20$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%'
});
const $16c5a599774d5a20$var$avatarContainerStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.100',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    flex: '0 0 auto'
});
const $16c5a599774d5a20$var$textStyles = (0, $8CUq3.xcss)({
    display: 'contents',
    wordWrap: 'break-word',
    overflow: 'hidden',
    color: 'color.text.subtle',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});

});
parcelRegister("eV9WL", function(module, exports) {

$parcel$export(module.exports, "default", () => $109194a127fc57c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17a702f64ead8e9c0f6992bf4974db90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $109194a127fc57c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "userProfile_directoryBaseV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
$109194a127fc57c7$var$node.hash = "32feb6e507f926d7932dcef23d9427a7";
var $109194a127fc57c7$export$2e2bcd8739ae039 = $109194a127fc57c7$var$node;

});

parcelRegister("2QW4M", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $155c7596e61d6af0$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $155c7596e61d6af0$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("7Aak7")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/ui/profilecard/index.tsx"
});
const $155c7596e61d6af0$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($155c7596e61d6af0$var$LazyComponent, props)));
var $155c7596e61d6af0$export$2e2bcd8739ae039 = $155c7596e61d6af0$export$a3c0845f856d4292;

});
parcelRegister("7Aak7", function(module, exports) {

let $5853e73cf6762011$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5853e73cf6762011$var$load("h2MrD"),
    $5853e73cf6762011$var$load("bYT2S"),
    $5853e73cf6762011$var$load("cM9em"),
    $5853e73cf6762011$var$load("fr9NE"),
    $5853e73cf6762011$var$load("lRPIy")
]).then(()=>parcelRequire('kKeZ6'));

});




parcelRegister("1Hnw6", function(module, exports) {

$parcel$export(module.exports, "NameCell", () => $86fdd751cdcb86f6$export$2e923ef80ad8608a);

var $fZsDk = parcelRequire("fZsDk");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $41j30 = parcelRequire("41j30");

var $k71ZQ = parcelRequire("k71ZQ");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
const $86fdd751cdcb86f6$export$2d483fceb9cca990 = (key, navigationMetadata, projectStyle)=>{
    if (!navigationMetadata) return `/browse/${key}`;
    if (navigationMetadata.__typename === 'JiraSoftwareProjectNavigationMetadata') {
        if (projectStyle === 'TEAM_MANAGED_PROJECT') return `/jira/software/projects/${key}/boards/${navigationMetadata.boardId}`;
        if (projectStyle === 'COMPANY_MANAGED_PROJECT') return `/jira/software/c/projects/${key}/boards/${navigationMetadata.boardId}`;
    }
    if (navigationMetadata.__typename === 'JiraServiceManagementProjectNavigationMetadata') return (0, $4R6GH.fg)('fix_jsm_queue_redirect_issue_from_project_list') ? `/jira/servicedesk/projects/${key}` : `/jira/servicedesk/projects/${key}/queues/custom/${navigationMetadata.queueId}`;
    return `/browse/${key}`;
};
const $86fdd751cdcb86f6$var$LinkComponent = ({ href: href, children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $86fdd751cdcb86f6$var$linkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: href,
        xcss: $86fdd751cdcb86f6$var$linkStyles
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$Link, {
        href: href
    }, children);
};
const $86fdd751cdcb86f6$export$2e923ef80ad8608a = ({ project: project })=>{
    const data = (0, $8Uumt.useFragment)((0, $fZsDk.default), project);
    const boardUrl = $86fdd751cdcb86f6$export$2d483fceb9cca990(data?.key, data?.navigationMetadata, data?.projectStyle);
    if (data?.avatar?.medium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$Container, null, (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: data.name,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$LinkComponent, {
        href: boardUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $86fdd751cdcb86f6$var$AvatarStyles,
        as: "img",
        src: data.avatar.medium,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$WithAvatarLabel, null, data.name))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$LinkComponent, {
        href: boardUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $86fdd751cdcb86f6$var$AvatarStyles,
        as: "img",
        src: data.avatar.medium,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$WithAvatarLabel, null, data.name)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$Container, null, (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: data.name,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$LinkComponent, {
        href: boardUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$NoAvatarLabel, null, data.name))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$LinkComponent, {
        href: boardUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86fdd751cdcb86f6$var$NoAvatarLabel, null, data.name)));
};
const $86fdd751cdcb86f6$export$29a344cbda7670b7 = '24px'; // When we need to display a label for a project that has no avatar, we need to ensure that the label is aligned
// with other labels that have avatars. To do this we need to have a larger left margin to account for the avatar
// (24px / space.300) and the gap (8px / space.100) between the avatar and the label.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86fdd751cdcb86f6$var$NoAvatarLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _18u0xy5q _1bto1l2s",
            __cmplp.className
        ])
    });
}); // When we need to display a label for a project that has an avatar, we need to just ensure that there is a gap
const $86fdd751cdcb86f6$var$WithAvatarLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $86fdd751cdcb86f6$var$AvatarStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.050',
    display: 'inline-block',
    verticalAlign: 'middle'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86fdd751cdcb86f6$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1reo15vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86fdd751cdcb86f6$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k71ZQ.CellWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reon7od _18m9n7od _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $86fdd751cdcb86f6$var$linkWrapperStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $86fdd751cdcb86f6$var$linkStyles = (0, $8CUq3.xcss)({
    display: 'block'
});

});
parcelRegister("fZsDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbcfd3f392f5769$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59e34681b681f5451cb425b4f17ea24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $acbcfd3f392f5769$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "nameCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "medium"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "boardId"
                        }
                    ],
                    "type": "JiraSoftwareProjectNavigationMetadata"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "queueId"
                        }
                    ],
                    "type": "JiraServiceManagementProjectNavigationMetadata"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$acbcfd3f392f5769$var$node.hash = "ba733526a1242d306b4f0b4e62066653";
var $acbcfd3f392f5769$export$2e2bcd8739ae039 = $acbcfd3f392f5769$var$node;

});


parcelRegister("kf2VM", function(module, exports) {

$parcel$export(module.exports, "ProjectCategoryCell", () => $8dd3a0b626ca709f$export$1bd789d7a92e69d5);

var $iILWc = parcelRequire("iILWc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");

var $k71ZQ = parcelRequire("k71ZQ");

var $4R6GH = parcelRequire("4R6GH");
const $8dd3a0b626ca709f$export$1bd789d7a92e69d5 = ({ project: project })=>{
    const data = (0, $8Uumt.useFragment)((0, $iILWc.default), project);
    if (data?.category?.name && (0, $4R6GH.fg)('blu-6080-directory-table-tooltips')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, data?.category?.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k71ZQ.CellWrapper), null, data?.category?.name);
};

});
parcelRegister("iILWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9bdd904e13889b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49b4670d3a84ed70a8d64a8fc967a301>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c9bdd904e13889b1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectCategoryCell_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraProjectCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$c9bdd904e13889b1$var$node.hash = "8895769fe267fb6dd387e5807f5f7fe1";
var $c9bdd904e13889b1$export$2e2bcd8739ae039 = $c9bdd904e13889b1$var$node;

});


parcelRegister("65Pfm", function(module, exports) {

$parcel$export(module.exports, "ProjectTypeCell", () => $b95a4f1456c2cb80$export$8052dbb4a8a7e741);

var $bjQBi = parcelRequire("bjQBi");

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");

var $k71ZQ = parcelRequire("k71ZQ");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $1mECc = parcelRequire("1mECc");
const $b95a4f1456c2cb80$var$projectTypeLabels = {
    COMPANY_MANAGED_PROJECT: {
        BUSINESS: (0, $1mECc.default).companyManagedBusiness,
        SOFTWARE: (0, $1mECc.default).companyManagedSoftware,
        SERVICE_DESK: (0, $1mECc.default).companyManagedServiceProject,
        PRODUCT_DISCOVERY: (0, $1mECc.default).productDiscoveryProject,
        CUSTOMER_SERVICE: (0, $1mECc.default).customerServiceProjectNonFinal
    },
    TEAM_MANAGED_PROJECT: {
        BUSINESS: (0, $1mECc.default).teamManagedBusiness,
        SOFTWARE: (0, $1mECc.default).teamManagedSoftware,
        SERVICE_DESK: (0, $1mECc.default).teamManagedServiceProject,
        PRODUCT_DISCOVERY: (0, $1mECc.default).productDiscoveryProject,
        CUSTOMER_SERVICE: (0, $1mECc.default).customerServiceProjectNonFinal
    }
};
const $b95a4f1456c2cb80$export$8052dbb4a8a7e741 = ({ project: project })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { projectType: projectType, projectStyle: projectStyle } = (0, $8Uumt.useFragment)((0, $bjQBi.default), project);
    const projectStyleKey = projectStyle || 'TEAM_MANAGED_PROJECT';
    const label = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($b95a4f1456c2cb80$var$projectTypeLabels, [
        projectStyleKey,
        projectType || ''
    ]);
    if ((0, $4R6GH.fg)('blu-6080-directory-table-tooltips')) {
        const finalLabel = label ? formatMessage(label) : projectType;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, finalLabel);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k71ZQ.CellWrapper), null, label ? formatMessage(label) : projectType);
};

});
parcelRegister("bjQBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b43a4434e331c6a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9458663dc6de45ac7a4376a22ee51ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b43a4434e331c6a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectTypeCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$b43a4434e331c6a8$var$node.hash = "070d0af17c4bb3ec3f4ea5c84d8914ff";
var $b43a4434e331c6a8$export$2e2bcd8739ae039 = $b43a4434e331c6a8$var$node;

});

parcelRegister("1mECc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc33c325b6b85b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9bc33c325b6b85b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    teamManagedBusiness: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.team-managed-business",
        "defaultMessage": "Team-managed business"
    },
    companyManagedBusiness: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.company-managed-business",
        "defaultMessage": "Company-managed business"
    },
    companyManagedServiceProject: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.company-managed-service-project",
        "defaultMessage": "Service management"
    },
    teamManagedServiceProject: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.team-managed-service-project",
        "defaultMessage": "Team-managed service management"
    },
    companyManagedSoftware: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.company-managed-software",
        "defaultMessage": "Company-managed software"
    },
    teamManagedSoftware: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.team-managed-software",
        "defaultMessage": "Team-managed software"
    },
    productDiscoveryProject: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.product-discovery-project",
        "defaultMessage": "Product Discovery"
    },
    customerServiceProjectNonFinal: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.customer-service-project-non-final",
        "defaultMessage": "Customer service"
    }
});

});


parcelRegister("3TDIg", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $c616a251894259db$export$110272e30ac53e5);

var $12DqC = parcelRequire("12DqC");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $jOyH3 = parcelRequire("jOyH3");

var $3bDjY = parcelRequire("3bDjY");
const $c616a251894259db$export$110272e30ac53e5 = ({ project: project })=>{
    const data = (0, $8Uumt.useFragment)((0, $12DqC.default), project);
    if (!data?.projectUrl) return null;
    const { projectUrl: projectUrl } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c616a251894259db$var$UrlCellContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: projectUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        href: projectUrl,
        target: "_blank",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: projectUrl
        })
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c616a251894259db$var$UrlCellContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("12DqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc5c3a790efcbf4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6375b0f75c09e09474a3ff052c13200>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bdc5c3a790efcbf4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "urlCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectUrl"
        }
    ],
    "type": "JiraProject"
};
$bdc5c3a790efcbf4$var$node.hash = "bc3c770944d0003a95b4fc28334d594a";
var $bdc5c3a790efcbf4$export$2e2bcd8739ae039 = $bdc5c3a790efcbf4$var$node;

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});






parcelRegister("qB72M", function(module, exports) {

$parcel$export(module.exports, "RefinementBar", () => $de420aeb16fb521a$export$1772ce3730aa9a66);

var $gHOaW = parcelRequire("gHOaW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gsfYl = parcelRequire("gsfYl");

var $ijnJK = parcelRequire("ijnJK");

var $eneeA = parcelRequire("eneeA");

var $aKLxh = parcelRequire("aKLxh");

var $hJiWC = parcelRequire("hJiWC");

var $lOzQH = parcelRequire("lOzQH");
const $de420aeb16fb521a$var$Filters = ({ dataRef: dataRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $gHOaW.default), dataRef);
    const shouldShowCategories = data.jira && Boolean(data.jira?.allJiraProjectCategories?.edges?.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eneeA.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), {
        expandOnSmall: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lOzQH.SearchControl), null)), data?.jira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJiWC.ProjectTypePicker), {
        dataRef: data.jira
    })), shouldShowCategories && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKLxh.ProjectCategoryPicker), {
        dataRef: data.jira
    })));
};
const $de420aeb16fb521a$export$1772ce3730aa9a66 = ({ dataRef: dataRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gsfYl.RefinementBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de420aeb16fb521a$var$Filters, {
        dataRef: dataRef
    }));

});
parcelRegister("gHOaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc502ca7a6e9feac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<78595a404e5a2998fb1503dd6011f88a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dc502ca7a6e9feac$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ],
    "kind": "Fragment",
    "name": "refinementBar_projectsDirectoryV3_Filters",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraProjectCategoryConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectCategories",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectCategoryEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectCategoryPicker_projectsDirectoryV3"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "projectTypePicker_projectsDirectoryV3"
                }
            ]
        }
    ],
    "type": "Query"
};
$dc502ca7a6e9feac$var$node.hash = "44ad103870f84d678e5203337cb09f3c";
var $dc502ca7a6e9feac$export$2e2bcd8739ae039 = $dc502ca7a6e9feac$var$node;

});

parcelRegister("gsfYl", function(module, exports) {

$parcel$export(module.exports, "RefinementBar", () => $9847a28eabdb9f07$export$1772ce3730aa9a66);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

const $9847a28eabdb9f07$export$1772ce3730aa9a66 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9847a28eabdb9f07$var$wrapperStyles
    }, children);
};
const $9847a28eabdb9f07$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});

parcelRegister("ijnJK", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $82ad612f888d18b7$export$3cf161fcd24b6b4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $82ad612f888d18b7$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: expandOnSmall ? [
            $82ad612f888d18b7$var$filterItemContainerStyles,
            $82ad612f888d18b7$var$filterItemContainerExpandedStyles
        ] : $82ad612f888d18b7$var$filterItemContainerStyles
    }, children);
};
const $82ad612f888d18b7$var$filterItemContainerStyles = (0, $8CUq3.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $82ad612f888d18b7$var$filterItemContainerExpandedStyles = (0, $8CUq3.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("eneeA", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $b95c1e2c9fc07d20$export$56a20ec2552ffba2);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $dCm1o = parcelRequire("dCm1o");

const $b95c1e2c9fc07d20$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $5uXOq.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b95c1e2c9fc07d20$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b95c1e2c9fc07d20$var$filterBarSharedStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && $b95c1e2c9fc07d20$var$filterBarLargeStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && containerWidth > (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && $b95c1e2c9fc07d20$var$filterBarMidStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && containerWidth > (0, $3ab203d2ecb98f35$export$54280d191a58e9f6) && $b95c1e2c9fc07d20$var$filterBarSmallStyles
        ]
    }, children));
};
const $b95c1e2c9fc07d20$var$relativeWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStyles = (0, $8CUq3.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh = (0, $8CUq3.xcss)({
    columnGap: 'space.100'
});
const $b95c1e2c9fc07d20$var$filterBarSmallStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarMidStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarLargeStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
const $3ab203d2ecb98f35$export$54280d191a58e9f6 = 420;
const $3ab203d2ecb98f35$export$99041d531d62aef9 = 640;
const $3ab203d2ecb98f35$export$9cc428d7e02a0e8b = 850;
const $3ab203d2ecb98f35$export$a4477e829bcd1e02 = 200;


parcelRegister("aKLxh", function(module, exports) {

$parcel$export(module.exports, "ProjectCategoryPicker", () => $1a698ceca317d045$export$307a32ce3626da26);

var $lHEuD = parcelRequire("lHEuD");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $7K5PP = parcelRequire("7K5PP");

var $1Jl81 = parcelRequire("1Jl81");

var $4R6GH = parcelRequire("4R6GH");

var $dZhZb = parcelRequire("dZhZb");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gkT9B = parcelRequire("gkT9B");

var $dPvGX = parcelRequire("dPvGX");

var $6psbp = parcelRequire("6psbp");
const $1a698ceca317d045$export$307a32ce3626da26 = ({ dataRef: dataRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'refinementBar'
    });
    const [value, { updateFilter: updateFilter }] = (0, $dPvGX.useScopedFilter)((0, $gkT9B.FilterFields).ProjectCategoryId);
    const data = (0, $8Uumt.useFragment)((0, $lHEuD.default), dataRef);
    const onChange = (0, $5uXOq.useCallback)((newValue)=>{
        updateFilter({
            [(0, $gkT9B.FilterFields).ProjectCategoryId]: newValue ? String(newValue.value) : '',
            [(0, $gkT9B.FilterFields).ProjectCategoryLabel]: newValue ? String(newValue.label) : ''
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'ProjectCategoryPicker');
    }, [
        updateFilter,
        analyticsEvent
    ]);
    const options = (0, $5uXOq.useMemo)(()=>data?.allJiraProjectCategories?.edges?.map((edge)=>({
                value: edge?.node?.id ? ((0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $1Jl81.AnyAri).parse(edge?.node?.id) : (0, $dXq4S.getAriConfig)(edge?.node?.id)).resourceId : '',
                label: edge?.node?.name || ''
            })) || [], [
        data
    ]);
    const selectedValue = (0, $5uXOq.useMemo)(()=>(0, $dZhZb.matchValueToSelectOptions)(value, options), [
        value,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a698ceca317d045$var$SelectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        "aria-label": formatMessage((0, $6psbp.default).ariaLabel),
        placeholder: formatMessage((0, $6psbp.default).placeholder),
        isClearable: true,
        name: (0, $gkT9B.FilterFields).ProjectCategoryId,
        value: selectedValue,
        onChange: onChange,
        options: options
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a698ceca317d045$var$SelectWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lHEuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $739203250c4d55bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf601ef97dd8c80990689dbf69ca6155>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $739203250c4d55bf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "projectCategoryPicker_projectsDirectoryV3",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraProjectCategoryConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectCategories",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraProjectCategory",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$739203250c4d55bf$var$node.hash = "9e121ef0e1f18f545400a0c2ac559c3f";
var $739203250c4d55bf$export$2e2bcd8739ae039 = $739203250c4d55bf$var$node;

});

parcelRegister("6psbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3751d830a949ad13$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3751d830a949ad13$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-category-picker.placeholder",
        "defaultMessage": "All categories"
    },
    ariaLabel: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-category-picker.aria-label",
        "defaultMessage": "Select a project category"
    }
});

});


parcelRegister("hJiWC", function(module, exports) {

$parcel$export(module.exports, "ProjectTypePicker", () => $a0cc4f9ef4ac5cfd$export$964395abe5900b56);

var $dcQdC = parcelRequire("dcQdC");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");

var $dZhZb = parcelRequire("dZhZb");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gkT9B = parcelRequire("gkT9B");

var $dPvGX = parcelRequire("dPvGX");

var $lv5Gx = parcelRequire("lv5Gx");
const $a0cc4f9ef4ac5cfd$var$PROJECT_TYPE_LABELS = {
    software: (0, $lv5Gx.default).softwareSpork,
    business: (0, $lv5Gx.default).businessSpork,
    service_desk: (0, $lv5Gx.default).serviceDesk,
    customer_service: (0, $lv5Gx.default).customerService,
    product_discovery: (0, $lv5Gx.default).productDiscovery
};
const $a0cc4f9ef4ac5cfd$var$PROJECT_TYPE_ORDER = {
    software: 2,
    service_desk: 3,
    business: 1,
    product_discovery: 4
}; // JCA11Y-148 - Provide override Input component to remove aria-describedby attribute that attached by placeholder prop,
// since it is conflicted with A11Y comaptibility with aria-label screen announcement, see https://react-select.com/props#components
/* @ts-expect-error - TS2304 - Cannot find name 'SelectComponents' and 'GroupBase' */ const $a0cc4f9ef4ac5cfd$var$Input = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Input, {
        ...props,
        "aria-describedby": undefined
    }, children);
const $a0cc4f9ef4ac5cfd$export$964395abe5900b56 = ({ dataRef: dataRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'refinementBar'
    });
    const [value, { updateFilter: updateFilter }] = (0, $dPvGX.useScopedFilter)((0, $gkT9B.FilterFields).ProjectType);
    const data = (0, $8Uumt.useFragment)((0, $dcQdC.default), dataRef);
    const onChange = (0, $5uXOq.useCallback)((newValue)=>{
        updateFilter({
            [(0, $gkT9B.FilterFields).ProjectType]: (0, $dZhZb.serializeSelectOptions)(newValue),
            [(0, $gkT9B.FilterFields).ProjectTypeLabel]: (0, $dZhZb.serializeSelectOptionsLabel)(newValue)
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'ProjectTypePicker');
    }, [
        updateFilter,
        analyticsEvent
    ]);
    const options = (0, $5uXOq.useMemo)(()=>[
            ...data?.allJiraProjectTypes?.edges?.map((edge)=>{
                const projectTypeKey = edge?.node?.key || '';
                const labelMessage = projectTypeKey && $a0cc4f9ef4ac5cfd$var$PROJECT_TYPE_LABELS[projectTypeKey];
                return {
                    value: projectTypeKey,
                    label: labelMessage ? formatMessage(labelMessage) : '',
                    order: $a0cc4f9ef4ac5cfd$var$PROJECT_TYPE_ORDER[projectTypeKey]
                };
            }) || []
        ].sort((a, b)=>a.order - b.order), [
        data,
        formatMessage
    ]);
    const selectedValue = (0, $5uXOq.useMemo)(()=>(0, $dZhZb.matchValueToSelectOptions)(value, options), [
        value,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0cc4f9ef4ac5cfd$var$SelectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94bNw.default), {
        'aria-label': formatMessage((0, $lv5Gx.default).placeholderSpork),
        components: {
            Input: $a0cc4f9ef4ac5cfd$var$Input
        },
        styles: {
            menu: ({ width: width, ...css })=>({
                    ...css,
                    width: 'max-content',
                    minWidth: '100%'
                })
        },
        placeholder: formatMessage((0, $lv5Gx.default).placeholderSpork),
        isMulti: true,
        name: (0, $gkT9B.FilterFields).ProjectType,
        value: selectedValue,
        onChange: onChange,
        options: options
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0cc4f9ef4ac5cfd$var$SelectWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dcQdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2807597a572d32$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5069b1b49714552a977f06f7c2dc5a32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ff2807597a572d32$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "projectTypePicker_projectsDirectoryV3",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraProjectTypeDetailsConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraProjectTypeDetailsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraProjectTypeDetails",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$ff2807597a572d32$var$node.hash = "f75b948f55a1e98fe58f7b24532671ea";
var $ff2807597a572d32$export$2e2bcd8739ae039 = $ff2807597a572d32$var$node;

});

parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $itpgN = parcelRequire("itpgN");

var $7K5PP = parcelRequire("7K5PP");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});

parcelRegister("lv5Gx", function(module, exports) {

$parcel$export(module.exports, "default", () => $69246b2863575212$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69246b2863575212$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderSpork: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.placeholder-spork",
        "defaultMessage": "Filter by product"
    },
    productDiscovery: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.product-discovery",
        "defaultMessage": "Jira Product Discovery"
    },
    softwareSpork: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.software-spork",
        "defaultMessage": "Jira - software projects"
    },
    serviceDesk: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.service-desk",
        "defaultMessage": "Jira Service Management"
    },
    customerService: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.customer-service",
        "defaultMessage": "Jira Customer Service"
    },
    businessSpork: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.business-spork",
        "defaultMessage": "Jira - business projects"
    }
});

});


parcelRegister("lOzQH", function(module, exports) {

$parcel$export(module.exports, "SearchControl", () => $f6f7425010dc3c75$export$e8511ccde7917fd2);

var $5uXOq = parcelRequire("5uXOq");

var $8WLYr = parcelRequire("8WLYr");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gkT9B = parcelRequire("gkT9B");

var $dCm1o = parcelRequire("dCm1o");

var $dPvGX = parcelRequire("dPvGX");

var $hz3am = parcelRequire("hz3am");
const $f6f7425010dc3c75$export$e8511ccde7917fd2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'refinementBar'
    });
    const [value, { updateFilter: updateFilter }] = (0, $dPvGX.useScopedFilter)((0, $gkT9B.FilterFields).Keyword);
    const onChange = (0, $5uXOq.useCallback)((newValue)=>{
        updateFilter((0, $gkT9B.FilterFields).Keyword, newValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'FilterSearch');
    }, [
        analyticsEvent,
        updateFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WLYr.SearchControl), {
        name: (0, $gkT9B.FilterFields).Keyword,
        value: value,
        onChange: onChange,
        placeholderAlwaysVisible: true,
        placeholder: formatMessage((0, $dCm1o.isVisualRefreshEnabled)() ? (0, $hz3am.default).placeholder : (0, $hz3am.default).placeholderOld)
    });
};

});
parcelRegister("8WLYr", function(module, exports) {

$parcel$export(module.exports, "SearchControl", () => $34b91ff110207eec$export$e8511ccde7917fd2);

var $5uXOq = parcelRequire("5uXOq");

var $jDrwg = parcelRequire("jDrwg");

var $2xSAL = parcelRequire("2xSAL");

var $dCm1o = parcelRequire("dCm1o");
const $34b91ff110207eec$export$e8511ccde7917fd2 = ({ name: name, value: value, onChange: onChange, placeholder: placeholder, placeholderAlwaysVisible: placeholderAlwaysVisible })=>{
    const [onInputChange] = (0, $jDrwg.default)((newValue)=>{
        onChange(newValue);
    }, 500);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        id: name,
        shouldFitContainerWidth: true,
        value: value,
        onChange: onInputChange,
        isAutocompleteDisabled: true,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        placeholder: placeholder,
        showIconBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)()
    });
};

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});


parcelRegister("hz3am", function(module, exports) {

$parcel$export(module.exports, "default", () => $d919549c7300ed1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d919549c7300ed1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "projects-directory-v3.page-layout.refinement-bar.search-control.placeholder",
        "defaultMessage": "Search projects"
    },
    placeholderOld: {
        "id": "projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-old",
        "defaultMessage": "Search Projects"
    }
});

});





parcelRegister("5qVrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $34104383eeaa69f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $bVDE5 = parcelRequire("bVDE5");
const $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bVDE5.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $34104383eeaa69f9$var$SpaErrorBoundary = $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData;
var $34104383eeaa69f9$export$2e2bcd8739ae039 = $34104383eeaa69f9$var$SpaErrorBoundary;

});

parcelRegister("hQFKP", function(module, exports) {

$parcel$export(module.exports, "METRICS_CONFIG", () => $55fecdb370260ae8$export$ccca72d76a53907e);

var $gkT9B = parcelRequire("gkT9B");
const $55fecdb370260ae8$export$ccca72d76a53907e = {
    default: {
        sourceName: 'projectsV3',
        experienceKey: (0, $gkT9B.PROJECTS_DIRECTORY_EXPERIENCE),
        experienceSource: 'projects-directory-v3',
        errorBoundary: 'spa-app-bootstrap.directories.projects-v3',
        appNameV2: 'directory.projects-v3',
        appNameV3: 'projectsDirectoryV3'
    },
    admin: {
        sourceName: 'projectsManageV3',
        experienceKey: (0, $gkT9B.MANAGE_PROJECTS_DIRECTORY_EXPERIENCE),
        experienceSource: 'projects-directory-manage-v3',
        errorBoundary: 'spa-app-bootstrap.directories.projects-manage-v3',
        appNameV2: 'directory.projects-manage-v3',
        appNameV3: 'projectsDirectoryManageV3'
    }
};

});



//# sourceMappingURL=async-projects-directory-v3.2f7fbdf6.js.map
